export const Attachment = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M3.81245 9.78791C3.37655 7.39065 4.83263 5.02754 7.21244 4.50468C13.3728 3.15122 17.9112 3.20886 23.7131 4.49784C26.0905 5.02602 27.5424 7.38899 27.1067 9.78505L24.5357 23.9248C24.197 25.7872 22.7779 27.2829 20.9236 27.6635C16.3508 28.6022 14.6048 28.5415 10.0579 27.6388C8.17324 27.2647 6.71666 25.7596 6.37292 23.8692L3.81245 9.78791Z"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
      <rect
        className="bounty_prime_color_svg"
        x="12.9761"
        y="10.2148"
        width="4.71803"
        height="8.19448"
        rx="0.944549"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
    </svg>
  );
};
export const Front = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.05083 11.7631C4.618 12.2557 5.23948 12.4279 5.67403 12.4279H25.2774C25.9341 12.4279 26.4594 12.2073 26.8768 11.8543C28.8983 10.1443 26.6239 7.21065 24.0193 6.73487C17.4866 5.54158 11.2279 5.98737 6.87861 6.76108C4.31989 7.21625 2.08863 10.059 4.05083 11.7631Z"
        fill="#FBABA5"
      />
      <path
        d="M18.5137 15.5673C18.1704 15.5885 17.8366 15.5888 17.5002 15.569C16.164 15.4902 15.297 14.1084 15.5656 12.6933L15.6991 11.9898C15.9059 10.9002 16.7215 10.006 17.7469 9.95086C17.9112 9.94202 18.0686 9.94271 18.2323 9.95263C19.279 10.016 20.115 10.9205 20.3244 12.0237L20.4511 12.6915C20.7196 14.1061 19.8521 15.4848 18.5137 15.5673Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M23.1969 14.5427C23.1429 14.5435 23.089 14.5437 23.0352 14.5432C22.3975 14.5376 21.8838 14.2084 21.5524 13.7052C21.2181 13.1974 21.0763 12.5193 21.2015 11.8551L21.2107 11.8064C21.4036 10.7829 22.1664 9.94039 23.0942 9.94449C24.0403 9.94866 24.8181 10.8135 25.014 11.8529C25.1382 12.512 24.9983 13.1888 24.6667 13.6975C24.338 14.2019 23.8286 14.5332 23.1969 14.5427Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.60001 14.5427C7.54596 14.5435 7.49206 14.5437 7.43824 14.5432C6.80061 14.5376 6.28687 14.2084 5.95548 13.7052C5.62117 13.1974 5.47941 12.5193 5.60458 11.8551L5.61376 11.8064C5.80663 10.7829 6.56946 9.94039 7.49727 9.94449C8.44339 9.94866 9.22118 10.8135 9.41706 11.8529C9.54126 12.512 9.40138 13.1888 9.06982 13.6975C8.74107 14.2019 8.23167 14.5332 7.60001 14.5427Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M13.1157 15.5678C12.7724 15.589 12.4387 15.5893 12.1022 15.5695C10.7661 15.4907 9.89905 14.1089 10.1676 12.6938L10.3012 11.9903C10.508 10.9007 11.3235 10.0065 12.349 9.95135C12.5133 9.94251 12.6706 9.9432 12.8344 9.95311C13.8811 10.0165 14.717 10.921 14.9264 12.0242L15.0532 12.692C15.3217 14.1066 14.4541 15.4852 13.1157 15.5678Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M21.2693 23.9673C17.214 23.636 13.2698 23.7293 9.94281 23.997C6.1633 24.3011 1.88053 18.9504 5.67225 18.9504L25.2641 18.9504C25.3716 18.9638 25.4754 18.983 25.5757 19.0075C29.1686 19.8873 24.956 24.2685 21.2693 23.9673Z"
        fill="#FBABA5"
      />
      <path
        d="M12.105 15.8223C12.4483 15.8011 12.782 15.8008 13.1185 15.8207C14.4547 15.8994 15.3217 17.2813 15.0531 18.6964L14.9195 19.3999C14.7127 20.4895 13.8972 21.3836 12.8717 21.4388C12.7074 21.4476 12.5501 21.4469 12.3863 21.437C11.3396 21.3737 10.5037 20.4691 10.2943 19.3659L10.1675 18.6982C9.89904 17.2836 10.7666 15.9049 12.105 15.8223Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.42196 16.8464C7.47601 16.8456 7.52991 16.8454 7.58373 16.8459C8.22136 16.8515 8.7351 17.1807 9.06649 17.684C9.40081 18.1917 9.54256 18.8699 9.41739 19.5341L9.40821 19.5828C9.21534 20.6063 8.45251 21.4488 7.52471 21.4447C6.57859 21.4405 5.80079 20.5757 5.60491 19.5362C5.48072 18.8772 5.6206 18.2004 5.95215 17.6916C6.2809 17.1872 6.7903 16.856 7.42196 16.8464Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M23.0186 16.8464C23.0727 16.8456 23.1266 16.8454 23.1804 16.8459C23.818 16.8515 24.3318 17.1807 24.6632 17.684C24.9975 18.1917 25.1392 18.8699 25.0141 19.5341L25.0049 19.5828C24.812 20.6063 24.0492 21.4488 23.1214 21.4447C22.1753 21.4405 21.3975 20.5757 21.2016 19.5362C21.0774 18.8772 21.2173 18.2004 21.5488 17.6916C21.8776 17.1872 22.387 16.856 23.0186 16.8464Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M17.5039 15.8223C17.8472 15.8011 18.1809 15.8008 18.5174 15.8207C19.8536 15.8994 20.7206 17.2813 20.452 18.6964L20.3185 19.3999C20.1117 20.4895 19.2961 21.3836 18.2706 21.4388C18.1063 21.4476 17.949 21.4469 17.7852 21.437C16.7385 21.3737 15.9026 20.4691 15.6932 19.3659L15.5665 18.6982C15.298 17.2836 16.1655 15.9049 17.5039 15.8223Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Top = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0 18.9477C1.3834 4.89239 11.9203 1.00965 17.0158 0.825195C22.2958 0.874067 33.2846 4.56699 35 18.9477H29.9506C28.5211 14.8178 23.9328 6.59953 17.0158 6.76554C13.4651 7.55498 6.19763 11.0966 5.5336 18.9477H0Z"
        fill="#FBABA5"
      />
      <path
        d="M15.0627 3.66345C13.8613 3.89934 12.8192 4.24694 11.7124 4.7671C10.4059 5.38112 9.76801 7.06258 10.2649 8.39079L11.0259 10.4254C11.3952 11.4125 12.3104 11.9861 13.3329 11.7986C14.1841 11.6424 14.7454 11.4498 15.5574 11.0549C16.5541 10.5701 17.2381 9.46183 17.2933 8.32121L17.4041 6.0323C17.4775 4.51547 16.4221 3.39652 15.0627 3.66345Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.64667 8.31612C6.97912 8.8011 6.40073 9.32894 5.82748 9.96787C4.88098 11.0228 4.76582 12.8832 5.50217 14.0063L6.45597 15.461C7.01787 16.318 7.9522 16.5713 8.7723 15.9842C9.18885 15.686 9.49914 15.3992 9.86466 14.983C10.602 14.1433 10.8901 12.7681 10.6319 11.6175L10.2074 9.72575C9.87327 8.23677 8.71045 7.54329 7.64667 8.31612Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M3.85035 16.0502C3.67205 16.42 3.51626 16.7934 3.3755 17.1863C2.88639 18.5516 3.6037 20.3949 4.81319 21.0896L4.95804 21.1728C5.83844 21.6784 6.78668 21.4779 7.24468 20.5689C7.38334 20.2936 7.49041 20.0328 7.59257 19.7254C7.93721 18.6884 7.63809 17.3142 6.93455 16.3557L6.83985 16.2267C5.88387 14.9243 4.45744 14.7912 3.85035 16.0502Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M19.8704 3.66345C21.0718 3.89934 22.1139 4.24694 23.2207 4.7671C24.5272 5.38112 25.1651 7.06258 24.6682 8.39079L23.9072 10.4254C23.5379 11.4125 22.6227 11.9861 21.6002 11.7986C20.749 11.6424 20.1877 11.4498 19.3757 11.0549C18.379 10.5701 17.695 9.46183 17.6398 8.32121L17.529 6.0323C17.4556 4.51547 18.511 3.39652 19.8704 3.66345Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M27.2864 8.31637C27.954 8.80134 28.5324 9.32918 29.1056 9.96811C30.0521 11.0231 30.1673 12.8835 29.4309 14.0065L28.4771 15.4613C27.9152 16.3183 26.9809 16.5715 26.1608 15.9845C25.7443 15.6863 25.434 15.3994 25.0684 14.9832C24.3311 14.1436 24.043 12.7683 24.3012 11.6178L24.7257 9.72599C25.0598 8.23701 26.2227 7.54354 27.2864 8.31637Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M31.0828 16.0502C31.2611 16.42 31.4168 16.7934 31.5576 17.1863C32.0467 18.5516 31.3294 20.3949 30.1199 21.0896L29.9751 21.1728C29.0947 21.6784 28.1464 21.4779 27.6884 20.5689C27.5498 20.2936 27.4427 20.0328 27.3405 19.7254C26.9959 18.6884 27.295 17.3142 27.9986 16.3557L28.0933 16.2267C29.0492 14.9243 30.4757 14.7912 31.0828 16.0502Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Bottom = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M35 5.39017C33.6166 19.4455 23.0797 23.3282 17.9842 23.5127C12.7042 23.4638 1.71542 19.7709 5.39902e-06 5.39016L5.04941 5.39016C6.47892 9.52006 11.0672 17.7384 17.9842 17.5724C21.5349 16.7829 28.8024 13.2413 29.4664 5.39017L35 5.39017Z"
        fill="#FBABA5"
      />
      <path
        d="M19.9366 20.6744C21.1379 20.4386 22.1801 20.091 23.2868 19.5708C24.5933 18.9568 25.2313 17.2753 24.7344 15.9471L23.9733 13.9125C23.6041 12.9254 22.6889 12.3517 21.6664 12.5393C20.8152 12.6955 20.2539 12.8881 19.4419 13.283C18.4451 13.7678 17.7611 14.8761 17.7059 16.0167L17.5952 18.3056C17.5218 19.8224 18.5772 20.9414 19.9366 20.6744Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M27.3536 16.0218C28.0211 15.5368 28.5995 15.009 29.1728 14.37C30.1193 13.3151 30.2344 11.4547 29.4981 10.3316L28.5443 8.87686C27.9824 8.01985 27.048 7.76659 26.2279 8.35367C25.8114 8.65187 25.5011 8.93871 25.1356 9.35493C24.3982 10.1945 24.1102 11.5698 24.3684 12.7204L24.7929 14.6121C25.127 16.1011 26.2898 16.7946 27.3536 16.0218Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M31.1492 8.28771C31.3275 7.91793 31.4833 7.54448 31.624 7.15156C32.1131 5.78627 31.3958 3.94302 30.1863 3.24833L30.0415 3.16514C29.1611 2.65947 28.2128 2.86003 27.7548 3.76904C27.6162 4.04425 27.5091 4.30512 27.4069 4.61251C27.0623 5.64951 27.3614 7.02366 28.065 7.98214L28.1597 8.11115C29.1156 9.41354 30.5421 9.54674 31.1492 8.28771Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M15.1318 20.6744C13.9304 20.4386 12.8883 20.091 11.7815 19.5708C10.475 18.9568 9.8371 17.2753 10.334 15.9471L11.095 13.9125C11.4643 12.9254 12.3795 12.3517 13.402 12.5393C14.2532 12.6955 14.8145 12.8881 15.6265 13.283C16.6232 13.7678 17.3072 14.8761 17.3624 16.0167L17.4732 18.3056C17.5466 19.8224 16.4912 20.9414 15.1318 20.6744Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.71478 16.0218C7.04723 15.5368 6.46885 15.009 5.8956 14.37C4.94909 13.3151 4.83393 11.4547 5.57029 10.3316L6.52409 8.87686C7.08599 8.01985 8.02032 7.76659 8.84041 8.35367C9.25697 8.65187 9.56726 8.93871 9.93278 9.35493C10.6701 10.1945 10.9582 11.5698 10.7 12.7204L10.2755 14.6121C9.94138 16.1011 8.77856 16.7946 7.71478 16.0218Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M3.9192 8.28771C3.7409 7.91793 3.58511 7.54448 3.44435 7.15156C2.95524 5.78626 3.67255 3.94302 4.88204 3.24833L5.02689 3.16514C5.90729 2.65947 6.85553 2.86003 7.31353 3.76904C7.45219 4.04425 7.55926 4.30512 7.66142 4.61251C8.00606 5.64951 7.70694 7.02366 7.00339 7.98214L6.9087 8.11115C5.95272 9.41354 4.52629 9.54674 3.9192 8.28771Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Lower = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 41 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M2.03728 7.63273C3.06376 5.93098 4.37687 5.3787 5.22917 5.3787L35.821 5.3787C37.4269 5.57867 38.5135 6.6043 39.2319 7.95612C40.9676 11.2225 37.1941 14.087 33.5245 13.6215C24.0825 12.4236 14.6624 12.8602 7.83861 13.658C4.03922 14.1023 0.0615019 10.9082 2.03728 7.63273Z"
        fill="#FBABA5"
      />
      <path
        d="M13.7447 0.497875C15.4056 0.230871 16.8086 0.238041 18.3895 0.493455C19.7483 0.712983 20.6023 2.08024 20.3368 3.47901L19.6293 7.20648C19.4261 8.27728 18.609 9.13335 17.5567 9.30664C16.424 9.49315 15.7394 9.48265 14.6117 9.29678C13.5395 9.12003 12.7016 8.25747 12.4957 7.17255L11.795 3.48078C11.5294 2.08177 12.3847 0.7165 13.7447 0.497875Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M6.64632 2.02201C7.66543 1.89092 8.58202 1.89301 9.56072 2.0184C10.9102 2.19128 11.7645 3.56073 11.5005 4.96186L11.0607 7.29543C10.858 8.37126 10.0437 9.23954 8.998 9.38015C8.35903 9.46608 7.87917 9.46143 7.24336 9.37364C6.17704 9.22641 5.34201 8.35099 5.13666 7.26127L4.70368 4.96365C4.43966 3.56261 5.29528 2.1958 6.64632 2.02201Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M31.0018 2.02201C32.0209 1.89092 32.9375 1.89301 33.9162 2.0184C35.2657 2.19128 36.12 3.56073 35.8559 4.96186L35.4162 7.29543C35.2134 8.37126 34.3992 9.23954 33.3535 9.38015C32.7145 9.46608 32.2346 9.46143 31.5988 9.37364C30.5325 9.22641 29.6975 8.35099 29.4921 7.26127L29.0591 4.96365C28.7951 3.56261 29.6507 2.1958 31.0018 2.02201Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M22.1697 0.497874C23.8307 0.230871 25.2336 0.238041 26.8145 0.493455C28.1734 0.712983 29.0274 2.08024 28.7619 3.47901L28.0544 7.20648C27.8512 8.27728 27.034 9.13335 25.9817 9.30664C24.8491 9.49315 24.1644 9.48265 23.0368 9.29678C21.9645 9.12003 21.1266 8.25747 20.9207 7.17255L20.22 3.48078C19.9545 2.08177 20.8097 0.7165 22.1697 0.497874Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Upper = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 35 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M0.93062 7.13865C1.85709 8.76356 3.26207 9.2627 4.12523 9.2627H30.8103C32.3389 9.2627 33.3446 8.38447 33.9865 7.2288C35.2721 4.91411 33.269 2.3746 30.679 1.82504C20.4102 -0.353796 10.4605 0.558075 4.21624 1.84571C1.6709 2.37059 -0.356647 4.88095 0.93062 7.13865Z"
        fill="#FBABA5"
      />
      <path
        d="M22.5874 13.5462C21.4103 13.7079 20.3689 13.7048 19.2416 13.5501C17.8865 13.3642 17.0304 11.9929 17.2965 10.5906L17.7994 7.94142C18.0032 6.86732 18.8185 6.00416 19.8668 5.85332C20.6289 5.74366 21.1684 5.7496 21.9267 5.86068C22.9954 6.01722 23.8321 6.88746 24.0386 7.97535L24.5346 10.5888C24.8008 11.9912 23.9438 13.3598 22.5874 13.5462Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M28.7775 12.2052C28.1437 12.2666 27.548 12.2664 26.9337 12.2079C25.5914 12.0803 24.7329 10.7059 24.9979 9.29954L25.2683 7.86456C25.4722 6.78262 26.2858 5.90155 27.3231 5.79963C27.6828 5.76428 27.9952 5.76628 28.3533 5.80352C29.4115 5.91357 30.2459 6.80308 30.4524 7.89872L30.716 9.29776C30.981 10.7038 30.1216 12.0751 28.7775 12.2052Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M7.54626 12.2052C6.91251 12.2666 6.31683 12.2664 5.70247 12.2079C4.3602 12.0803 3.5017 10.7059 3.76673 9.29954L4.03715 7.86456C4.24104 6.78262 5.05463 5.90155 6.09185 5.79963C6.45161 5.76428 6.76401 5.76628 7.12206 5.80352C8.18034 5.91357 9.01469 6.80308 9.22116 7.89872L9.4848 9.29776C9.74977 10.7038 8.8904 12.0751 7.54626 12.2052Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M15.2393 13.5464C14.0622 13.7081 13.0207 13.7051 11.8934 13.5503C10.5384 13.3644 9.68224 11.9931 9.9484 10.5908L10.4512 7.94166C10.6551 6.86757 11.4703 6.00441 12.5187 5.85357C13.2808 5.74391 13.8203 5.74984 14.5786 5.86092C15.6472 6.01747 16.484 6.8877 16.6904 7.97559L17.1865 10.5891C17.4527 11.9914 16.5957 13.36 15.2393 13.5464Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Right = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.68837 6.05938C20.5508 4.30263 23.0186 7.08194 22.7851 8.91251V21.1957C22.7851 21.7166 22.7405 22.2492 22.5115 22.7171C20.7994 26.2157 14.3681 25.8313 9.18326 24.7061C6.65387 24.1572 4.99976 21.8254 4.99976 19.2371V11.7634C4.99976 8.96923 6.93003 6.50547 9.68837 6.05938Z"
        fill="#FBABA5"
      />
      <path
        d="M24.2193 12.6659C24.4707 14.0563 23.6274 15.4086 22.304 15.5432C21.6761 15.6071 21.0865 15.6068 20.4779 15.546C19.1565 15.4139 18.314 14.0585 18.5655 12.6677L18.8606 11.0359C19.0566 9.95223 19.8618 9.0629 20.8944 8.96193C21.2274 8.92937 21.5202 8.9312 21.8516 8.96557C22.906 9.07494 23.7324 9.97344 23.9309 11.0714L24.2193 12.6659Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M12.7063 12.7731C12.9572 14.1708 12.107 15.5262 10.8037 15.5842C10.5963 15.5934 10.392 15.5937 10.1875 15.5853C8.88673 15.5317 8.03697 14.1733 8.28804 12.7749L8.39512 12.1786C8.59245 11.0796 9.39876 10.1648 10.4062 10.1479C10.4538 10.1471 10.5013 10.1473 10.5489 10.1484C11.5785 10.1724 12.406 11.1008 12.6059 12.2143L12.7063 12.7731Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M18.2467 12.7224C18.5013 14.1206 17.6504 15.4799 16.3319 15.5716C15.9598 15.5975 15.5995 15.5978 15.2354 15.5734C13.9192 15.4854 13.069 14.123 13.3237 12.7242L13.4985 11.7639C13.6971 10.6729 14.5045 9.7713 15.5261 9.7142C15.6884 9.70513 15.8438 9.70581 16.0054 9.71593C17.0491 9.78127 17.8774 10.694 18.0787 11.7992L18.2467 12.7224Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M24.2193 18.4571C24.4707 17.0667 23.6274 15.7145 22.304 15.5799C21.6761 15.516 21.0865 15.5162 20.4779 15.5771C19.1565 15.7091 18.314 17.0646 18.5655 18.4553L18.8606 20.0872C19.0566 21.1708 19.8618 22.0601 20.8944 22.1611C21.2274 22.1937 21.5202 22.1918 21.8516 22.1575C22.906 22.0481 23.7324 21.1496 23.9309 20.0517L24.2193 18.4571Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M12.7063 18.3499C12.9572 16.9523 12.107 15.5968 10.8037 15.5389C10.5963 15.5296 10.392 15.5293 10.1875 15.5378C8.88673 15.5913 8.03697 16.9498 8.28804 18.3481L8.39512 18.9445C8.59245 20.0434 9.39876 20.9582 10.4062 20.9751C10.4538 20.9759 10.5013 20.9758 10.5489 20.9747C11.5785 20.9506 12.406 20.0223 12.6059 18.9088L12.7063 18.3499Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M18.247 18.4006C18.5016 17.0024 17.6506 15.6432 16.3321 15.5514C15.96 15.5256 15.5997 15.5253 15.2356 15.5496C13.9194 15.6376 13.0692 17 13.3239 18.3988L13.4987 19.3591C13.6974 20.4502 14.5047 21.3518 15.5264 21.4088C15.6886 21.4179 15.844 21.4172 16.0057 21.4071C17.0493 21.3418 17.8777 20.4291 18.0789 19.3239L18.247 18.4006Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const Left = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M20.8104 6.05938C9.94801 4.30263 7.48021 7.08194 7.71371 8.91251V21.1957C7.71371 21.7166 7.75833 22.2492 7.98728 22.7171C9.69937 26.2157 16.1307 25.8313 21.3155 24.7061C23.8449 24.1572 25.499 21.8254 25.499 19.2371V11.7634C25.499 8.96923 23.5687 6.50547 20.8104 6.05938Z"
        fill="#FBABA5"
      />
      <path
        d="M8.19522 15.5432C8.82319 15.6071 9.41279 15.6068 10.0214 15.546C11.3428 15.4139 12.1853 14.0585 11.9338 12.6677L11.6387 11.0359C11.4427 9.95223 10.6375 9.0629 9.60485 8.96193C9.2719 8.92937 8.97905 8.9312 8.64771 8.96557C7.5933 9.07494 6.7669 9.97344 6.56834 11.0714L6.27997 12.6659C6.02852 14.0563 6.8719 15.4086 8.19522 15.5432Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M19.6954 15.5842C19.9027 15.5934 20.107 15.5937 20.3115 15.5853C21.6123 15.5317 22.4621 14.1733 22.211 12.7749L22.1039 12.1786C21.9066 11.0796 21.1003 10.1648 20.0929 10.1479C20.0452 10.1471 19.9977 10.1473 19.9501 10.1484C18.9205 10.1724 18.093 11.1008 17.8931 12.2143L17.7927 12.7731C17.5418 14.1708 18.392 15.5262 19.6954 15.5842Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M14.1669 15.5716C14.539 15.5975 14.8993 15.5978 15.2634 15.5734C16.5796 15.4854 17.4298 14.123 17.1751 12.7242L17.0003 11.7639C16.8016 10.6729 15.9943 9.7713 14.9727 9.7142C14.8104 9.70513 14.655 9.70581 14.4934 9.71593C13.4497 9.78127 12.6213 10.694 12.4201 11.7992L12.252 12.7224C11.9975 14.1206 12.8484 15.4799 14.1669 15.5716Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M8.19547 15.5799C8.82343 15.516 9.41304 15.5162 10.0216 15.5771C11.343 15.7091 12.1855 17.0646 11.934 18.4553L11.6389 20.0872C11.4429 21.1708 10.6377 22.0601 9.6051 22.1611C9.27215 22.1937 8.97929 22.1918 8.64795 22.1575C7.59354 22.0481 6.76715 21.1496 6.56859 20.0517L6.28022 18.4571C6.02877 17.0667 6.87215 15.7145 8.19547 15.5799Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M19.6956 15.5389C19.903 15.5296 20.1072 15.5293 20.3118 15.5378C21.6125 15.5913 22.4623 16.9498 22.2112 18.3481L22.1041 18.9445C21.9068 20.0434 21.1005 20.9582 20.0931 20.9751C20.0454 20.9759 19.998 20.9758 19.9504 20.9747C18.9207 20.9506 18.0933 20.0223 17.8933 18.9088L17.793 18.3499C17.542 16.9523 18.3923 15.5968 19.6956 15.5389Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
      <path
        d="M14.1669 15.5514C14.539 15.5256 14.8993 15.5253 15.2634 15.5496C16.5796 15.6376 17.4298 17 17.1751 18.3988L17.0003 19.3591C16.8016 20.4502 15.9943 21.3518 14.9727 21.4088C14.8104 21.4179 14.655 21.4172 14.4933 21.4071C13.4497 21.3418 12.6213 20.4291 12.4201 19.3239L12.252 18.4006C11.9975 17.0024 12.8484 15.6432 14.1669 15.5514Z"
        fill="white"
        stroke="#C4C4C4"
        strokeWidth="0.6"
      />
    </svg>
  );
};
export const SuperImpose = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M15.9682 6.64536C11.924 5.40865 9.96558 5.15206 6.80274 5.84436C4.67147 6.31086 3.39452 8.45852 3.7549 10.6103L4.88382 17.3509C5.17497 19.0894 6.47425 20.5382 8.19748 20.9089C8.82979 21.0449 9.31427 21.0933 10.0563 21.0479"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
        strokeLinecap="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M12.5797 16.1899C11.8803 14.1233 12.8037 11.8025 14.8565 11.0635C17.2174 10.2137 19.2632 9.89591 21.6508 9.95772C23.8306 10.0141 25.4353 11.9287 25.4232 14.1092L25.385 21.0022C25.3753 22.7367 24.3506 24.3446 22.7167 24.9266C21.1984 25.4673 20.2111 25.6103 18.6145 25.5758C16.8523 25.5376 15.3357 24.3333 14.7707 22.6637L12.5797 16.1899Z"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
    </svg>
  );
};
export const BackStep = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M27.5001 10.4249V19.5749C27.5001 21.4499 25.4626 22.6249 23.8376 21.6874L19.8751 19.3999L15.9126 17.1124L15.3 16.7624V13.2374L15.9126 12.8874L19.8751 10.5999L23.8376 8.31241C25.4626 7.37491 27.5001 8.54991 27.5001 10.4249Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M15.3 10.4249V19.5749C15.3 21.4499 13.2626 22.6249 11.6501 21.6874L7.67507 19.3999L3.71255 17.1124C2.10005 16.1749 2.10005 13.8249 3.71255 12.8874L7.67507 10.5999L11.6501 8.31241C13.2626 7.37491 15.3 8.54991 15.3 10.4249Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const ForwardStep = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        opacity="0.4"
        d="M2.5 10.4249V19.5749C2.5 21.4499 4.53749 22.6249 6.16249 21.6874L10.125 19.3999L14.0875 17.1124L14.7 16.7624V13.2374L14.0875 12.8874L10.125 10.5999L6.16249 8.31241C4.53749 7.37491 2.5 8.54991 2.5 10.4249Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.7 10.4249V19.5749C14.7 21.4499 16.7374 22.6249 18.3499 21.6874L22.3249 19.3999L26.2874 17.1124C27.8999 16.1749 27.8999 13.8249 26.2874 12.8874L22.3249 10.5999L18.3499 8.31241C16.7374 7.37491 14.7 8.54991 14.7 10.4249Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const SkipFirst = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M20.24 7.22006V16.7901C20.24 18.7501 18.11 19.9801 16.41 19.0001L12.26 16.6101L8.10996 14.2101C6.40996 13.2301 6.40996 10.7801 8.10996 9.80006L12.26 7.40006L16.41 5.01006C18.11 4.03006 20.24 5.25006 20.24 7.22006Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M3.76001 18.9301C3.35001 18.9301 3.01001 18.5901 3.01001 18.1801V5.82007C3.01001 5.41007 3.35001 5.07007 3.76001 5.07007C4.17001 5.07007 4.51001 5.41007 4.51001 5.82007V18.1801C4.51001 18.5901 4.17001 18.9301 3.76001 18.9301Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const SkipLast = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M3.76004 7.22006V16.7901C3.76004 18.7501 5.89004 19.9801 7.59004 19.0001L11.74 16.6101L15.89 14.2101C17.59 13.2301 17.59 10.7801 15.89 9.80006L11.74 7.40006L7.59004 5.01006C5.89004 4.03006 3.76004 5.25006 3.76004 7.22006Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        d="M20.24 18.9301C20.65 18.9301 20.99 18.5901 20.99 18.1801V5.82007C20.99 5.41007 20.65 5.07007 20.24 5.07007C19.83 5.07007 19.49 5.41007 19.49 5.82007V18.1801C19.49 18.5901 19.83 18.9301 20.24 18.9301Z"
        fill="#898A8D"
      />
    </svg>
  );
};
export const Play = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_play"
        d="M19.9501 36.6666C29.1549 36.6666 36.6168 29.2047 36.6168 19.9999C36.6168 10.7952 29.1549 3.33325 19.9501 3.33325C10.7454 3.33325 3.28345 10.7952 3.28345 19.9999C3.28345 29.2047 10.7454 36.6666 19.9501 36.6666Z"
        fill="#00B189"
      />
      <path
        d="M24.9501 17.05L20.1168 14.2667C18.9168 13.5667 17.4668 13.5667 16.2668 14.2667C15.0668 14.9667 14.3501 16.2 14.3501 17.6V23.1834C14.3501 24.5667 15.0668 25.8167 16.2668 26.5167C16.8668 26.8667 17.5334 27.0334 18.1834 27.0334C18.8501 27.0334 19.5001 26.8667 20.1001 26.5167L24.9334 23.7334C26.1334 23.0334 26.8501 21.8 26.8501 20.4C26.8834 19 26.1668 17.75 24.9501 17.05Z"
        fill="white"
      />
    </svg>
  );
};
export const Pause = () => {
  return (
    <svg
      width="40"
      height="40"
      viewBox="0 0 40 40"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_pause"
        d="M19.9499 36.6667C29.1546 36.6667 36.6165 29.2048 36.6165 20C36.6165 10.7953 29.1546 3.33337 19.9499 3.33337C10.7451 3.33337 3.2832 10.7953 3.2832 20C3.2832 29.2048 10.7451 36.6667 19.9499 36.6667Z"
        fill="#00B189"
      />
      <path
        d="M19.1 24.74V15.26C19.1 14.36 18.72 14 17.76 14H15.34C14.38 14 14 14.36 14 15.26V24.74C14 25.64 14.38 26 15.34 26H17.76C18.72 26 19.1 25.64 19.1 24.74Z"
        fill="white"
      />
      <path
        d="M26.0004 24.74V15.26C26.0004 14.36 25.6204 14 24.6604 14H22.2404C21.2871 14 20.9004 14.36 20.9004 15.26V24.74C20.9004 25.64 21.2804 26 22.2404 26H24.6604C25.6204 26 26.0004 25.64 26.0004 24.74Z"
        fill="white"
      />
    </svg>
  );
};
export const PlayMobile = () => {
  return (
    <svg
      width="52"
      height="39"
      viewBox="0 0 52 39"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M20 12L31.6667 19.5L20 27V12Z" fill="#2E2E2F" />
    </svg>
  );
};
export const PauseMobile = () => {
  return (
    <svg
      width="52"
      height="38"
      viewBox="0 0 52 38"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path d="M28 26H32V12H28M20 26H24V12H20V26Z" fill="black" />
    </svg>
  );
};
export const Shrink = () => {
  return (
    <svg
      width="48"
      height="51"
      viewBox="0 0 48 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M37.2422 20.6623C37.2422 20.8844 37.1541 21.0972 36.997 21.2546L28.1036 20.6262C27.5442 20.0667 27.2299 19.3084 27.2299 18.5179L27.2299 12.3249C27.2299 12.026 27.3896 11.7495 27.6487 11.5999L27.649 11.5998C27.9078 11.4503 28.2273 11.4503 28.4861 11.5998L28.4863 11.5999C28.7455 11.7495 28.9052 12.026 28.9052 12.3249L28.9052 18.5179C28.9052 18.8648 29.0431 19.197 29.288 19.4418C29.5329 19.6867 29.865 19.8247 30.212 19.8247L36.4049 19.8247C36.6268 19.8247 36.8399 19.9129 36.9971 20.0701C37.1539 20.2269 37.2422 20.4399 37.2422 20.6623L37.2422 20.6623ZM36.997 21.2546L28.1036 20.6263C28.6631 21.1856 29.4214 21.4999 30.212 21.4999L36.4049 21.4999C36.6267 21.4999 36.8397 21.4118 36.997 21.2546Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M28.0676 39.5123C27.8455 39.5123 27.6326 39.4242 27.4752 39.2671L28.1036 30.3738C28.6631 29.8144 29.4215 29.5001 30.212 29.5001L36.4049 29.5001C36.7039 29.5001 36.9804 29.6597 37.13 29.9189L37.1301 29.9191C37.2796 30.1779 37.2796 30.4974 37.1301 30.7563L37.13 30.7565C36.9804 31.0157 36.7039 31.1753 36.4049 31.1753L30.212 31.1753C29.865 31.1753 29.5329 31.3133 29.288 31.5582C29.0432 31.803 28.9052 32.1351 28.9052 32.4821L28.9052 38.6751C28.9052 38.8969 28.817 39.11 28.6597 39.2673C28.503 39.424 28.29 39.5123 28.0676 39.5123L28.0676 39.5123ZM27.4752 39.2671L28.1036 30.3738C27.5442 30.9332 27.2299 31.6915 27.2299 32.4821L27.2299 38.6751C27.2299 38.8968 27.318 39.1098 27.4752 39.2671Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.1746 11.4877C19.3967 11.4877 19.6095 11.5758 19.767 11.7329L19.1386 20.6262C18.5791 21.1856 17.8207 21.4999 17.0302 21.4999H10.8373C10.5383 21.4999 10.2618 21.3403 10.1122 21.0811L10.1121 21.0809C9.96264 20.8221 9.96263 20.5026 10.1121 20.2437L10.1122 20.2435C10.2618 19.9843 10.5383 19.8247 10.8373 19.8247H17.0302C17.3772 19.8247 17.7093 19.6867 17.9542 19.4418C18.199 19.197 18.337 18.8649 18.337 18.5179V12.3249C18.337 12.1031 18.4252 11.89 18.5825 11.7327C18.7392 11.576 18.9522 11.4877 19.1746 11.4877L19.1746 11.4877ZM19.767 11.7329L19.1386 20.6262C19.698 20.0668 20.0122 19.3085 20.0122 18.5179V12.3249C20.0122 12.1032 19.9241 11.8902 19.767 11.7329Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10 30.3375C10 30.1154 10.0881 29.9025 10.2452 29.7451L19.1386 30.3735C19.698 30.933 20.0123 31.6913 20.0123 32.4819L20.0123 38.6748C20.0123 38.9738 19.8526 39.2503 19.5934 39.3999L19.5932 39.4C19.3344 39.5494 19.0149 39.5495 18.7561 39.4L18.7559 39.3999C18.4967 39.2503 18.337 38.9738 18.337 38.6748L18.337 32.4819C18.337 32.1349 18.1991 31.8028 17.9542 31.5579C17.7093 31.3131 17.3772 31.1751 17.0302 31.1751L10.8373 31.1751C10.6154 31.1751 10.4023 31.0869 10.2451 30.9296C10.0883 30.7729 10 30.5599 10 30.3375L10 30.3375ZM10.2452 29.7451L19.1385 30.3735C18.5791 29.8141 17.8208 29.4998 17.0302 29.4998L10.8373 29.4998C10.6155 29.4998 10.4025 29.5879 10.2452 29.7451Z"
        fill="black"
      />
    </svg>
  );
};
export const Expand = () => {
  return (
    <svg
      width="48"
      height="51"
      viewBox="0 0 48 51"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M27.23 12.3248C27.23 12.1027 27.3181 11.8899 27.4752 11.7325L36.3685 12.3609C36.928 12.9204 37.2422 13.6787 37.2422 14.4693L37.2422 20.6622C37.2422 20.9611 37.0826 21.2377 36.8234 21.3872L36.8232 21.3874C36.5644 21.5368 36.2449 21.5368 35.986 21.3873L35.9858 21.3872C35.7266 21.2377 35.567 20.9611 35.567 20.6622L35.567 14.4693C35.567 14.1223 35.429 13.7902 35.1841 13.5453C34.9393 13.3004 34.6072 13.1624 34.2602 13.1624L28.0672 13.1624C27.8454 13.1624 27.6323 13.0743 27.475 12.917C27.3183 12.7603 27.23 12.5473 27.23 12.3248L27.23 12.3248ZM27.4752 11.7325L36.3685 12.3609C35.8091 11.8015 35.0508 11.4872 34.2602 11.4872L28.0673 11.4872C27.8455 11.4872 27.6325 11.5753 27.4752 11.7325Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M36.4046 29.5006C36.6267 29.5006 36.8395 29.5886 36.997 29.7458L36.3685 38.6391C35.8091 39.1985 35.0507 39.5128 34.2602 39.5128H28.0672C27.7683 39.5128 27.4918 39.3532 27.3422 39.094L27.3421 39.0938C27.1926 38.8349 27.1926 38.5155 27.3421 38.2566L27.3422 38.2564C27.4918 37.9972 27.7683 37.8376 28.0672 37.8376H34.2602C34.6072 37.8376 34.9393 37.6996 35.1842 37.4547C35.429 37.2098 35.567 36.8778 35.567 36.5307V30.3378C35.567 30.116 35.6552 29.9029 35.8124 29.7456C35.9692 29.5889 36.1822 29.5006 36.4046 29.5005L36.4046 29.5006ZM36.997 29.7458L36.3686 38.6391C36.928 38.0797 37.2422 37.3213 37.2422 36.5308V30.3378C37.2422 30.1161 37.1541 29.903 36.997 29.7458Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.8376 21.4994C10.6155 21.4994 10.4027 21.4114 10.2452 21.2542L10.8737 12.3609C11.4331 11.8015 12.1915 11.4872 12.982 11.4872L19.175 11.4872C19.4739 11.4872 19.7504 11.6468 19.9 11.906C20.0494 12.1648 20.0496 12.4845 19.9001 12.7434C19.7505 13.0026 19.4739 13.1624 19.175 13.1624L12.982 13.1624C12.635 13.1624 12.3029 13.3004 12.058 13.5453C11.8132 13.7902 11.6752 14.1222 11.6752 14.4693L11.6752 20.6622C11.6752 20.884 11.587 21.0971 11.4297 21.2544C11.273 21.4111 11.06 21.4994 10.8376 21.4994ZM10.2452 21.2542L10.8737 12.3609C10.3143 12.9203 9.99996 13.6787 9.99996 14.4692L9.99996 20.6622C9.99996 20.8839 10.0881 21.097 10.2452 21.2542Z"
        fill="black"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.0122 38.674C20.0122 38.8961 19.9241 39.1089 19.767 39.2664L10.8736 38.6379C10.3142 38.0785 9.99994 37.3201 9.99994 36.5296L9.99994 30.3366C9.99994 30.0377 10.1596 29.7612 10.4188 29.6116L10.419 29.6115C10.6778 29.462 10.9973 29.462 11.2561 29.6115L11.2564 29.6116C11.5155 29.7612 11.6752 30.0377 11.6752 30.3366L11.6752 36.5296C11.6752 36.8766 11.8132 37.2087 12.0581 37.4536C12.3029 37.6984 12.635 37.8364 12.982 37.8364L19.175 37.8364C19.3968 37.8364 19.6099 37.9246 19.7671 38.0819C19.9239 38.2386 20.0122 38.4516 20.0122 38.674L20.0122 38.674ZM19.767 39.2664L10.8737 38.638C11.4331 39.1974 12.1914 39.5116 12.982 39.5116L19.1749 39.5116C19.3967 39.5116 19.6097 39.4235 19.767 39.2664Z"
        fill="black"
      />
    </svg>
  );
};
export const ZoomIn = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M10.25 15.125H19"
        stroke="#6C6C6C"
        strokeWidth="2.9085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.625 19.5V10.75"
        stroke="#6C6C6C"
        strokeWidth="2.9085"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.375 26.75C20.9334 26.75 26.25 21.4334 26.25 14.875C26.25 8.31662 20.9334 3 14.375 3C7.81662 3 2.5 8.31662 2.5 14.875C2.5 21.4334 7.81662 26.75 14.375 26.75Z"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M27.5 28L25 25.5"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const ZoomOut = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M9.75 15.125H19"
        stroke="#6C6C6C"
        strokeWidth="2.52739"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.375 26.75C20.9334 26.75 26.25 21.4334 26.25 14.875C26.25 8.31662 20.9334 3 14.375 3C7.81662 3 2.5 8.31662 2.5 14.875C2.5 21.4334 7.81662 26.75 14.375 26.75Z"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M27.5 28L25 25.5"
        stroke="#6C6C6C"
        strokeWidth="2.0775"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Pontics = () => {
  return (
    <svg
      width="31"
      height="31"
      viewBox="0 0 29 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M7.47958 14.3118C7.47958 13.7374 7.01395 13.2718 6.43958 13.2718C5.8652 13.2718 5.39958 13.7374 5.39958 14.3118H7.47958ZM7.47958 17.019V14.3118H5.39958V17.019H7.47958Z"
        fill="#6C6C6C"
      />
      <path
        d="M24.6254 14.3118C24.6254 13.7374 24.1598 13.2718 23.5854 13.2718C23.0111 13.2718 22.5454 13.7374 22.5454 14.3118H24.6254ZM24.6254 17.019V14.3118H22.5454V17.019H24.6254Z"
        fill="#6C6C6C"
      />
      <path
        d="M11.3171 3.98349C11.0874 2.64909 11.8948 1.468 13.0315 1.28559C14.4749 1.05397 15.7215 1.05937 17.0974 1.28051C18.231 1.46271 19.0383 2.6453 18.8083 3.98125L18.0868 8.17389C17.9064 9.22248 17.1428 10.0183 16.2186 10.1658C15.3757 10.3004 14.803 10.294 13.9577 10.157L13.7912 11.1836L13.9577 10.157C12.9984 10.0015 12.2127 9.18811 12.0305 8.12923L11.3171 3.98349Z"
        stroke="#6C6C6C"
        strokeWidth="2.08"
      />
      <path
        d="M3.0304 17.1194H26.8943"
        stroke="#6C6C6C"
        strokeWidth="2.08"
        strokeLinecap="round"
      />
      <path
        d="M20.127 3.9618C19.9026 2.63295 20.7036 1.46224 21.8273 1.28058C23.218 1.05578 24.4225 1.0609 25.7486 1.27548C26.8692 1.45683 27.6702 2.62916 27.4456 3.95954L26.7331 8.17891C26.5557 9.22957 25.7957 10.0261 24.8783 10.1721C24.0874 10.298 23.5395 10.2921 22.7464 10.1637C21.7931 10.0094 21.0105 9.19445 20.8314 8.13349L20.127 3.9618Z"
        stroke="#6C6C6C"
        strokeWidth="2.08"
      />
      <path
        d="M2.47978 3.96274C2.25541 2.63389 3.05634 1.46317 4.1801 1.28152C5.57077 1.05672 6.77533 1.06184 8.10136 1.27642C9.222 1.45776 10.023 2.6301 9.79836 3.96048L9.08593 8.17985C8.90853 9.2305 8.14846 10.027 7.2311 10.173C6.44021 10.2989 5.89227 10.293 5.09915 10.1646C4.14591 10.0103 3.3633 9.19539 3.18416 8.13443L2.47978 3.96274Z"
        stroke="#6C6C6C"
        strokeWidth="2.08"
      />
    </svg>
  );
};
export const Split = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 28 34"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M14.1301 2L14.1301 32"
        stroke="#6C6C6C"
        strokeWidth="2.075"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M13.13 2.9624H9.88003C6.6527 2.9624 4.12367 3.60151 2.42766 5.29753C0.731641 6.99354 0.0925293 9.52257 0.0925293 12.7499V20.2499C0.0925293 23.4772 0.731641 26.0063 2.42766 27.7023C4.12367 29.3983 6.6527 30.0374 9.88003 30.0374H13.13V27.9624H9.88003C6.85736 27.9624 5.01139 27.3515 3.8949 26.235C2.77842 25.1185 2.16753 23.2726 2.16753 20.2499V12.7499C2.16753 9.72723 2.77842 7.88126 3.8949 6.76478C5.01139 5.64829 6.85736 5.0374 9.88003 5.0374H13.13V2.9624Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M15.505 2.9624C14.932 2.9624 14.4675 3.42691 14.4675 3.9999C14.4675 4.5729 14.932 5.0374 15.505 5.0374H17.38C17.9909 5.0374 18.5573 5.06239 19.0817 5.11239C19.6521 5.16678 20.1586 4.74846 20.213 4.17805C20.2674 3.60764 19.849 3.10115 19.2786 3.04676C18.6795 2.98964 18.0467 2.9624 17.38 2.9624H15.505ZM23.114 4.06047C22.6034 3.80047 21.9787 4.00364 21.7187 4.51425C21.4587 5.02487 21.6618 5.64957 22.1725 5.90956C23.0893 6.37639 23.7535 7.04067 24.2204 7.95748C24.4804 8.4681 25.1051 8.67126 25.6157 8.41127C26.1263 8.15128 26.3295 7.52657 26.0695 7.01596C25.4036 5.70831 24.4216 4.7263 23.114 4.06047ZM27.0832 10.8513C27.0288 10.2809 26.5223 9.86257 25.9519 9.91696C25.3815 9.97134 24.9632 10.4778 25.0175 11.0483C25.0675 11.5727 25.0925 12.139 25.0925 12.7499V14.6249C25.0925 15.1979 25.557 15.6624 26.13 15.6624C26.703 15.6624 27.1675 15.1979 27.1675 14.6249V12.7499C27.1675 12.0832 27.1403 11.4504 27.0832 10.8513ZM27.1675 18.3749C27.1675 17.8019 26.703 17.3374 26.13 17.3374C25.557 17.3374 25.0925 17.8019 25.0925 18.3749V20.2499C25.0925 20.8608 25.0675 21.4271 25.0175 21.9516C24.9632 22.522 25.3815 23.0285 25.9519 23.0828C26.5223 23.1372 27.0288 22.7189 27.0832 22.1485C27.1403 21.5494 27.1675 20.9166 27.1675 20.2499V18.3749ZM26.0695 25.9838C26.3295 25.4732 26.1263 24.8485 25.6157 24.5885C25.1051 24.3285 24.4804 24.5317 24.2204 25.0423C23.7535 25.9591 23.0893 26.6234 22.1725 27.0902C21.6618 27.3502 21.4587 27.9749 21.7187 28.4856C21.9787 28.9962 22.6034 29.1993 23.114 28.9393C24.4216 28.2735 25.4036 27.2915 26.0695 25.9838ZM19.2786 29.953C19.849 29.8987 20.2674 29.3922 20.213 28.8218C20.1586 28.2513 19.6521 27.833 19.0817 27.8874C18.5573 27.9374 17.9909 27.9624 17.38 27.9624H15.505C14.932 27.9624 14.4675 28.4269 14.4675 28.9999C14.4675 29.5729 14.932 30.0374 15.505 30.0374H17.38C18.0467 30.0374 18.6795 30.0102 19.2786 29.953Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Ipr = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 29 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.6846 3.02927L20.6899 1.46704L22.9648 1.96714L22.9605 3.03511C22.9589 3.66357 22.4481 4.17173 21.8196 4.17011C21.1912 4.1685 20.683 3.65773 20.6846 3.02927ZM21.8162 5.49997C22.4447 5.50158 22.9529 6.01235 22.9512 6.64081L22.942 10.2465C22.9404 10.875 22.4296 11.3831 21.8011 11.3815C21.1727 11.3799 20.6645 10.8691 20.6661 10.2407L20.6754 6.63498C20.677 6.00652 21.1878 5.49835 21.8162 5.49997ZM21.7977 12.7114C22.4262 12.713 22.9344 13.2238 22.9327 13.8522L22.9235 17.4579C22.9219 18.0864 22.4111 18.5946 21.7826 18.5929C21.1542 18.5913 20.646 18.0806 20.6476 17.4521L20.6569 13.8464C20.6585 13.2179 21.1693 12.7098 21.7977 12.7114ZM21.7792 19.9228C22.4077 19.9244 22.9159 20.4352 22.9142 21.0636L22.905 24.6693C22.9034 25.2978 22.3926 25.806 21.7641 25.8044C21.1357 25.8027 20.6275 25.292 20.6291 24.6635L20.6384 21.0578C20.64 20.4293 21.1508 19.9212 21.7792 19.9228ZM21.7607 27.1342C22.3892 27.1358 22.8974 27.6466 22.8957 28.2751L22.8957 29.2409L20.6199 30.2063L20.6199 28.2692C20.6215 27.6408 21.1323 27.1326 21.7607 27.1342Z"
        fill="#898A8D"
      />
      <path
        className="bounty_prime_color_svg"
        fillRule="evenodd"
        clipRule="evenodd"
        d="M20.3276 1.41699C15.2946 0.65458 10.7877 0.846831 5.09425 2.10265C1.80076 2.8291 -0.155698 6.09124 0.431117 9.33115L3.27442 25.0295C3.73931 27.5963 5.71084 29.6495 8.27693 30.1609C10.8149 30.6667 12.6508 30.9539 14.516 30.9666C16.2696 30.9785 18.002 30.7478 20.3276 30.2828V27.9193C17.8214 28.4355 16.161 28.6611 14.5316 28.65C12.8957 28.6389 11.2375 28.3891 8.72625 27.8886C7.10671 27.5659 5.84328 26.2634 5.54474 24.6151L2.70144 8.9167C2.32014 6.8115 3.59754 4.80468 5.58942 4.36532C11.1331 3.14254 15.4318 2.97892 20.3276 3.76111V1.41699ZM23.3276 25.154C23.3752 24.9988 23.414 24.8396 23.4435 24.677L26.2986 8.91351C26.6798 6.80861 25.4055 4.80109 23.4149 4.35711C23.3858 4.35061 23.3567 4.34414 23.3276 4.3377V1.96747C23.5224 2.00893 23.7183 2.05164 23.9154 2.09561C27.2048 2.8293 29.1553 6.09043 28.5689 9.32796L25.7138 25.0915C25.4262 26.679 24.5607 28.0774 23.3276 29.027V25.154Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Numbering = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M3.83638 8.73934C3.40047 6.34208 4.85692 3.97943 7.23628 3.45453C13.512 2.07006 18.121 2.12943 24.0306 3.44777C26.4075 3.97802 27.8596 6.34043 27.4239 8.73649L24.8068 23.1294C24.4681 24.9918 23.049 26.4871 21.1949 26.8685C16.5288 27.8286 14.7679 27.7664 10.128 26.8437C8.24345 26.469 6.78662 24.9642 6.44288 23.0738L3.83638 8.73934Z"
        stroke="#6C6C6C"
        strokeWidth="2.07801"
      />
      <path
        className="bounty_prime_color_svg"
        d="M14.3699 9L13.1099 20.3642"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M18.1621 9L16.9021 20.3642"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M10.2656 12.792H21.6299"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        className="bounty_prime_color_svg"
        d="M9.62988 16.5842H20.9941"
        stroke="#6C6C6C"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Grid = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M11.8799 27.5H19.3799C25.6299 27.5 28.1299 25 28.1299 18.75V11.25C28.1299 5 25.6299 2.5 19.3799 2.5H11.8799C5.62988 2.5 3.12988 5 3.12988 11.25V18.75C3.12988 25 5.62988 27.5 11.8799 27.5Z"
        stroke="#6C6C6C"
        strokeWidth="2.075"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <g opacity="0.4">
        <path
          d="M3.1665 9H28.129"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.1665 16H28.129"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M3.62988 23H26.6299"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M7.62988 26V4"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M15.6299 27.4872V2.51221"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M23.6299 26V4"
          stroke="#2E2E2F"
          strokeWidth="2.075"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
    </svg>
  );
};
export const Pan = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M5.47151 19.8859C5.86203 20.2765 6.4952 20.2765 6.88572 19.8859C7.27625 19.4954 7.27625 18.8623 6.88572 18.4717L5.47151 19.8859ZM2.00001 15.0002L1.29291 14.2931C0.902381 14.6836 0.902381 15.3168 1.29291 15.7073L2.00001 15.0002ZM6.88572 11.5287C7.27625 11.1382 7.27625 10.505 6.88572 10.1145C6.4952 9.724 5.86203 9.724 5.47151 10.1145L6.88572 11.5287ZM15 16.0003C15.5523 16.0003 16 15.5526 16 15.0003C16 14.448 15.5523 14.0003 15 14.0003L15 16.0003ZM6.88572 18.4717L2.70712 14.2931L1.29291 15.7073L5.47151 19.8859L6.88572 18.4717ZM2.70712 15.7073L6.88572 11.5287L5.47151 10.1145L1.29291 14.2931L2.70712 15.7073ZM2.00001 16.0002L15 16.0003L15 14.0003L2.00002 14.0002L2.00001 16.0002Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M24.6446 10.2304C24.2541 9.8399 23.6209 9.8399 23.2304 10.2304C22.8399 10.6209 22.8399 11.2541 23.2304 11.6446L24.6446 10.2304ZM28 15L28.7071 15.7071C29.0977 15.3166 29.0977 14.6834 28.7071 14.2929L28 15ZM23.2304 18.3554C22.8399 18.7459 22.8399 19.3791 23.2304 19.7696C23.6209 20.1602 24.2541 20.1602 24.6446 19.7696L23.2304 18.3554ZM15 14C14.4477 14 14 14.4477 14 15C14 15.5522 14.4477 16 15 16L15 14ZM23.2304 11.6446L27.2929 15.7071L28.7071 14.2929L24.6446 10.2304L23.2304 11.6446ZM27.2929 14.2929L23.2304 18.3554L24.6446 19.7696L28.7071 15.7071L27.2929 14.2929ZM15 16L28 16L28 14L15 14L15 16Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M19.7695 24.6448C20.16 24.2542 20.16 23.6211 19.7695 23.2305C19.3789 22.84 18.7458 22.84 18.3552 23.2305L19.7695 24.6448ZM14.9999 28.0001L14.2928 28.7072C14.6833 29.0978 15.3164 29.0978 15.707 28.7072L14.9999 28.0001ZM11.6445 23.2305C11.2539 22.84 10.6208 22.84 10.2303 23.2305C9.83973 23.6211 9.83973 24.2542 10.2303 24.6447L11.6445 23.2305ZM16 15C16 14.4477 15.5523 14 15 14C14.4478 14 14 14.4477 14 15L16 15ZM18.3552 23.2305L14.2928 27.293L15.707 28.7072L19.7695 24.6448L18.3552 23.2305ZM15.707 27.293L11.6445 23.2305L10.2303 24.6447L14.2928 28.7072L15.707 27.293ZM14 15L13.9999 28.0001L15.9999 28.0002L16 15L14 15Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M10.1143 5.4715C9.72377 5.86203 9.72377 6.49519 10.1143 6.88572C10.5048 7.27624 11.138 7.27624 11.5285 6.88572L10.1143 5.4715ZM15 2.00001L15.7071 1.2929C15.3166 0.902376 14.6834 0.902376 14.2929 1.2929L15 2.00001ZM18.4715 6.88572C18.862 7.27624 19.4952 7.27624 19.8857 6.88572C20.2762 6.49519 20.2762 5.86203 19.8857 5.47151L18.4715 6.88572ZM14 15C14 15.5523 14.4477 16 15 16C15.5523 16 16 15.5523 16 15L14 15ZM11.5285 6.88572L15.7071 2.70711L14.2929 1.2929L10.1143 5.4715L11.5285 6.88572ZM14.2929 2.70711L18.4715 6.88572L19.8857 5.47151L15.7071 1.2929L14.2929 2.70711ZM14 2L14 15L16 15L16 2.00001L14 2Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Rotate = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_prime_color_svg"
        d="M24.1971 5.80951C21.7404 3.35286 18.4741 2 14.9999 2C12.9057 2 10.824 2.50975 8.97991 3.47424C7.91655 4.03033 6.93114 4.73833 6.0577 5.56513V2H4.02539V9.11308H11.1385V7.08077H7.41234C9.43891 5.14627 12.1583 4.03231 14.9999 4.03231C21.0512 4.03231 25.9743 8.95538 25.9743 15.0067C25.9743 15.3437 25.9589 15.6833 25.9286 16.0163L27.9525 16.2006C27.9884 15.8067 28.0066 15.4051 28.0066 15.0069L26.9905 15.0068H28.0066C28.0066 11.5325 26.6537 8.26627 24.1971 5.80951Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M6.45008 21.8879L4.86768 23.1633C5.32738 23.7336 5.83882 24.2689 6.38784 24.7543L7.73394 23.2318C7.27027 22.8218 6.8383 22.3697 6.45008 21.8879Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M4.64632 18.6553L2.72949 19.3308C2.97306 20.0219 3.27801 20.6973 3.636 21.3386L5.41052 20.348C5.10867 19.8073 4.85158 19.2377 4.64632 18.6553Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M4.02547 15.0068H1.99316C1.99316 15.742 2.05515 16.4796 2.17729 17.1989L4.18095 16.8586C4.07775 16.2513 4.02547 15.6283 4.02547 15.0068Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M9.22494 24.3406L8.15381 26.0677C8.77727 26.4544 9.43747 26.7899 10.1159 27.065L10.8795 25.1816C10.3075 24.9498 9.7508 24.6667 9.22494 24.3406Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M25.6044 17.8442C25.445 18.4411 25.2331 19.0286 24.9746 19.5902L26.8207 20.4401C27.1274 19.7738 27.3788 19.0767 27.5679 18.3683L25.6044 17.8442Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M21.4809 23.8643C20.9813 24.2305 20.4477 24.5561 19.895 24.832L20.8028 26.6503C21.458 26.3232 22.0904 25.9373 22.6824 25.5034L21.4809 23.8643Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M24.0581 21.2048C23.7084 21.7147 23.3127 22.1986 22.8818 22.6433L24.3413 24.0576C24.8514 23.5312 25.3201 22.958 25.7342 22.3542L24.0581 21.2048Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M18.1687 25.5171C17.5777 25.6951 16.9665 25.8235 16.3521 25.8989L16.5996 27.9161C17.3284 27.8266 18.0533 27.6742 18.7545 27.4632L18.1687 25.5171Z"
        fill="#6C6C6C"
      />
      <path
        className="bounty_prime_color_svg"
        d="M12.6523 25.73L12.2197 27.7157C12.9338 27.8713 13.668 27.967 14.4021 28.0002L14.494 25.97C13.8742 25.942 13.2546 25.8611 12.6523 25.73Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Occ = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 29 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.94131 13.5817C8.9075 14.87 10.4671 15.6343 12.325 15.2917C13.0067 15.166 13.6916 15.0052 14.3314 14.8549C14.6411 14.7822 14.9403 14.7119 15.2235 14.6494C16.1279 14.4494 16.937 14.3098 17.7078 14.3064C18.4367 14.3032 19.1788 14.4194 19.9819 14.5932C20.363 14.6756 20.7473 14.7685 21.1495 14.8658L21.215 14.8816C21.6368 14.9835 22.077 15.0893 22.527 15.1845C24.3783 15.5759 25.9469 14.8437 26.9209 13.5662C27.8693 12.3224 28.2424 10.5938 27.9182 8.89547L26.5606 1.7843C26.4565 1.23867 25.9297 0.880792 25.3841 0.984954C24.8385 1.08911 24.4806 1.61587 24.5848 2.1615L25.9423 9.27267C26.1707 10.469 25.8878 11.6035 25.3213 12.3465C24.7804 13.0559 23.9751 13.4346 22.9431 13.2164C22.525 13.128 22.111 13.0287 21.6876 12.9263L21.6155 12.9089C21.2192 12.8131 20.8129 12.7148 20.4072 12.6271C19.5461 12.4408 18.6405 12.2907 17.6989 12.2949C16.7073 12.2993 15.7284 12.4776 14.7893 12.6852C14.4521 12.7597 14.1262 12.8364 13.8039 12.9122C13.194 13.0556 12.5969 13.1961 11.9602 13.3135C10.9186 13.5056 10.0997 13.107 9.55061 12.3748C8.97841 11.6118 8.69813 10.466 8.92657 9.26935L10.2835 2.1615C10.3876 1.61587 10.0298 1.08912 9.48413 0.984954C8.93851 0.880793 8.41175 1.23867 8.30759 1.7843L6.95069 8.89215C6.62626 10.5916 6.9982 12.3241 7.94131 13.5817Z"
        fill="#6C6C6C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M21.0587 18.3524C20.0925 17.0641 18.5329 16.2998 16.675 16.6424C15.9933 16.7681 15.3084 16.9289 14.6686 17.0792C14.3589 17.1519 14.0597 17.2221 13.7765 17.2847C12.8721 17.4846 12.063 17.6242 11.2922 17.6277C10.5633 17.6309 9.82125 17.5146 9.0181 17.3409C8.63699 17.2585 8.25274 17.1656 7.85046 17.0683L7.78499 17.0525C7.36322 16.9506 6.92302 16.8447 6.47299 16.7496C4.62171 16.3582 3.05313 17.0904 2.07909 18.3679C1.13073 19.6117 0.757598 21.3403 1.08182 23.0386L2.43935 30.1498C2.54352 30.6954 3.07027 31.0533 3.6159 30.9491C4.16152 30.845 4.5194 30.3182 4.41524 29.7726L3.0577 22.6614C2.82932 21.465 3.11216 20.3306 3.67873 19.5875C4.21961 18.8781 5.02493 18.4995 6.0569 18.7177C6.47496 18.8061 6.88897 18.9054 7.31241 19.0078L7.38449 19.0252C7.7808 19.121 8.18708 19.2192 8.59281 19.307C9.45385 19.4933 10.3595 19.6434 11.3011 19.6392C12.2927 19.6348 13.2716 19.4565 14.2107 19.2489C14.5479 19.1743 14.8738 19.0977 15.1961 19.0219C15.806 18.8785 16.4031 18.738 17.0398 18.6206C18.0814 18.4285 18.9003 18.8271 19.4494 19.5593C20.0216 20.3223 20.3019 21.4681 20.0734 22.6647L18.7165 29.7726C18.6124 30.3182 18.9702 30.845 19.5159 30.9491C20.0615 31.0533 20.5882 30.6954 20.6924 30.1498L22.0493 23.0419C22.3737 21.3425 22.0018 19.61 21.0587 18.3524Z"
        fill="#6C6C6C"
      />
      <path
        d="M13.0002 18.5955C13.0002 16.9386 11.881 15.5955 10.5002 15.5955C9.11953 15.5955 8.00024 16.9386 8.00024 18.5955C8.00024 20.2523 9.11953 21.5955 10.5002 21.5955C11.881 21.5955 13.0002 20.2523 13.0002 18.5955Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M10.5002 21.0399C9.42636 21.0399 8.5558 20.1693 8.5558 19.0955C8.5558 18.0216 9.42636 17.151 10.5002 17.151C11.5741 17.151 12.4447 18.0216 12.4447 19.0955C12.4447 20.1693 11.5741 21.0399 10.5002 21.0399ZM7.00024 19.0955C7.00024 21.0285 8.56725 22.5955 10.5002 22.5955C12.4332 22.5955 14.0002 21.0285 14.0002 19.0955C14.0002 17.1625 12.4332 15.5955 10.5002 15.5955C8.56725 15.5955 7.00024 17.1625 7.00024 19.0955Z"
        fill="#6C6C6C"
      />
      <path
        d="M21.0002 13.0955C21.0002 11.7147 19.881 10.5955 18.5002 10.5955C17.1195 10.5955 16.0002 11.7147 16.0002 13.0955C16.0002 14.4762 17.1195 15.5955 18.5002 15.5955C19.881 15.5955 21.0002 14.4762 21.0002 13.0955Z"
        fill="white"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5002 15.0399C17.4264 15.0399 16.5558 14.1693 16.5558 13.0955C16.5558 12.0216 17.4264 11.151 18.5002 11.151C19.5741 11.151 20.4447 12.0216 20.4447 13.0955C20.4447 14.1693 19.5741 15.0399 18.5002 15.0399ZM15.0002 13.0955C15.0002 15.0285 16.5672 16.5955 18.5002 16.5955C20.4332 16.5955 22.0002 15.0285 22.0002 13.0955C22.0002 11.1625 20.4332 9.59546 18.5002 9.59546C16.5672 9.59546 15.0002 11.1625 15.0002 13.0955Z"
        fill="#6C6C6C"
      />
    </svg>
  );
};
export const Tools = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 31 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_501_1187)">
        <path
          d="M16.4414 30.967H14.5586C13.0358 30.967 11.7968 29.7281 11.7968 28.2053V27.5684C11.1494 27.3615 10.5204 27.1004 9.91613 26.7877L9.46473 27.2391C8.37143 28.3338 6.62012 28.3017 5.55857 27.2387L4.22785 25.9081C3.16443 24.8458 3.13385 23.0951 4.2282 22.0019L4.67926 21.5508C4.36654 20.9466 4.10551 20.3177 3.89861 19.6702H3.2617C1.73896 19.6702 0.5 18.4313 0.5 16.9085V15.0256C0.5 13.5028 1.73896 12.2639 3.26176 12.2639H3.89867C4.10557 11.6165 4.3666 10.9875 4.67932 10.3832L4.22791 9.93188C3.1342 8.83935 3.16438 7.08845 4.22826 6.02573L5.5591 4.69495C6.62311 3.62948 8.374 3.60288 9.46519 4.6953L9.91619 5.1463C10.5205 4.83364 11.1495 4.57255 11.7969 4.36565V3.72874C11.7969 2.20595 13.0358 0.967041 14.5586 0.967041H16.4414C17.9642 0.967041 19.2031 2.20595 19.2031 3.72874V4.36571C19.8505 4.57255 20.4795 4.83364 21.0838 5.14636L21.5352 4.69495C22.6285 3.6003 24.3798 3.63241 25.4414 4.69536L26.7721 6.02603C27.8355 7.08827 27.8661 8.83899 26.7717 9.93218L26.3207 10.3832C26.6334 10.9875 26.8944 11.6164 27.1013 12.2639H27.7382C29.261 12.2639 30.5 13.5028 30.5 15.0256V16.9085C30.5 18.4313 29.261 19.6702 27.7382 19.6702H27.1013C26.8944 20.3176 26.6334 20.9466 26.3207 21.5508L26.7721 22.0023C27.8658 23.0948 27.8356 24.8457 26.7717 25.9084L25.4409 27.2392C24.3769 28.3047 22.626 28.3313 21.5348 27.2388L21.0838 26.7878C20.4795 27.1005 19.8505 27.3616 19.2031 27.5685V28.2055C19.2031 29.7281 17.9642 30.967 16.4414 30.967ZM10.21 24.9418C11.0495 25.4383 11.953 25.8134 12.8954 26.0566C13.2835 26.1567 13.5547 26.5068 13.5547 26.9076V28.2053C13.5547 28.7589 14.0051 29.2092 14.5586 29.2092H16.4414C16.995 29.2092 17.4454 28.7589 17.4454 28.2053V26.9076C17.4454 26.5068 17.7165 26.1567 18.1047 26.0566C19.0471 25.8134 19.9506 25.4383 20.7901 24.9418C21.1355 24.7376 21.5752 24.7931 21.859 25.0769L22.7782 25.9962C23.1746 26.393 23.811 26.3838 24.1976 25.9966L25.5293 24.665C25.9149 24.2798 25.9278 23.6432 25.5296 23.2456L24.61 22.3259C24.3263 22.0422 24.2707 21.6024 24.4749 21.2571C24.9714 20.4176 25.3464 19.5141 25.5896 18.5716C25.6898 18.1835 26.0398 17.9124 26.4406 17.9124H27.7383C28.2918 17.9124 28.7422 17.4621 28.7422 16.9085V15.0257C28.7422 14.4721 28.2918 14.0218 27.7383 14.0218H26.4406C26.0398 14.0218 25.6898 13.7506 25.5896 13.3625C25.3464 12.4201 24.9713 11.5166 24.4749 10.6771C24.2707 10.3318 24.3263 9.89198 24.61 9.60827L25.5293 8.68899C25.9266 8.29208 25.9163 7.65575 25.5296 7.26956L24.1981 5.93802C23.8121 5.55153 23.1755 5.54022 22.7786 5.93767L21.8591 6.8573C21.5754 7.14106 21.1354 7.19661 20.7901 6.99235C19.9507 6.49589 19.0471 6.12083 18.1047 5.87761C17.7166 5.77747 17.4454 5.42743 17.4454 5.02659V3.72874C17.4454 3.1752 16.995 2.72485 16.4415 2.72485H14.5587C14.0052 2.72485 13.5547 3.1752 13.5547 3.72874V5.02647C13.5547 5.42731 13.2836 5.77735 12.8954 5.87749C11.953 6.12071 11.0495 6.49577 10.21 6.99224C9.86457 7.19644 9.42482 7.14089 9.14111 6.85718L8.22189 5.9379C7.82557 5.5411 7.18906 5.5503 6.80252 5.93749L5.47086 7.26909C5.0852 7.65429 5.0723 8.29079 5.47051 8.68853L6.39014 9.60815C6.67385 9.89187 6.72939 10.3317 6.5252 10.677C6.02873 11.5164 5.65373 12.42 5.41051 13.3624C5.31031 13.7506 4.96027 14.0217 4.55949 14.0217H3.26176C2.70822 14.0217 2.25781 14.4721 2.25781 15.0256V16.9085C2.25781 17.462 2.70822 17.9124 3.26176 17.9124H4.55943C4.96027 17.9124 5.31025 18.1835 5.41045 18.5716C5.65367 19.5141 6.02873 20.4176 6.52514 21.257C6.72934 21.6024 6.67379 22.0422 6.39008 22.3259L5.4708 23.2451C5.07342 23.6421 5.08379 24.2784 5.47045 24.6646L6.80199 25.9961C7.18795 26.3826 7.82451 26.3939 8.22143 25.9965L9.141 25.0768C9.35006 24.8678 9.785 24.6905 10.21 24.9418Z"
          fill="#2E2E2F"
        />
        <path
          d="M15.5 22.4944C11.9008 22.4944 8.97266 19.5662 8.97266 15.967C8.97266 12.3679 11.9008 9.4397 15.5 9.4397C19.0992 9.4397 22.0273 12.3679 22.0273 15.967C22.0273 19.5662 19.0992 22.4944 15.5 22.4944ZM15.5 11.1975C12.87 11.1975 10.7305 13.3371 10.7305 15.967C10.7305 18.597 12.8701 20.7366 15.5 20.7366C18.1299 20.7366 20.2695 18.597 20.2695 15.967C20.2695 13.3371 18.13 11.1975 15.5 11.1975Z"
          fill="#2E2E2F"
        />
      </g>
      <defs>
        <clipPath id="clip0_501_1187">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0.5 0.967041)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};
export const Arrow = () => {
  return (
    <svg
      width="9"
      height="6"
      viewBox="0 0 9 6"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M6.73651 4.21355L4.30002 0.967041H0.693512C0.076355 0.967041 -0.232223 1.71277 0.20493 2.14993L3.53501 5.48C4.06859 6.01359 4.93647 6.01359 5.47005 5.48L6.73651 4.21355Z"
        fill="#292D32"
      />
      <path
        d="M8.30466 0.967041H4.29956L6.73605 4.21355L8.79967 2.14993C9.23039 1.71277 8.92181 0.967041 8.30466 0.967041Z"
        fill="#292D32"
      />
    </svg>
  );
};

export const Close = () => {
  return (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 21.0834C17.5 21.0834 22 16.7709 22 11.5001C22 6.22925 17.5 1.91675 12 1.91675C6.5 1.91675 2 6.22925 2 11.5001C2 16.7709 6.5 21.0834 12 21.0834Z"
        stroke="#898a8d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M9.16998 14.212L14.83 8.78784"
        stroke="#898a8d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M14.83 14.212L9.16998 8.78784"
        stroke="#898a8d"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
export const Staging = () => {
  return (
    <svg
      width="29"
      height="28"
      viewBox="0 0 29 28"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="7.90476"
        y="5.3746"
        width="8.19"
        height="3.19"
        stroke="#2E2E2F"
        strokeWidth="1.81"
      />
      <rect
        x="12.9048"
        y="12.1512"
        width="9.19"
        height="3.19"
        stroke="#2E2E2F"
        strokeWidth="1.81"
      />
      <rect
        x="7.69968"
        y="19.1512"
        width="9.19"
        height="3.19"
        stroke="#2E2E2F"
        strokeWidth="1.81"
      />
    </svg>
  );
};

export const BoltonIcon = () => {
  return (
    <svg
      width="16"
      height="20"
      viewBox="0 0 16 20"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.1082 17.2833L13.1092 17.2824C14.1959 16.3316 14.7181 15.0503 14.7181 13.5395C14.7181 12.4626 14.4008 11.4835 13.7625 10.6361C13.5162 10.3035 13.2372 10.0155 12.9274 9.77332C13.1383 9.5851 13.3316 9.37454 13.5064 9.14163C14.1096 8.35708 14.3825 7.40254 14.3825 6.34163C14.3825 4.881 13.861 3.64655 12.7828 2.74173C11.7304 1.8466 10.3297 1.45636 8.69732 1.45636H2.06995H1.16651V2.3598V17.7183V18.6217H2.06995H8.92802C10.6055 18.6217 12.0397 18.2152 13.1082 17.2833ZM8.74276 6.44401L8.75016 6.45067L8.7577 6.45718C8.83404 6.52296 8.9264 6.64628 8.9264 6.97609C8.9264 7.30348 8.8354 7.4274 8.75939 7.49355C8.67451 7.56515 8.46966 7.66976 8.00522 7.66976H6.55972V6.26055H8.00522C8.46204 6.26055 8.65915 6.36869 8.74276 6.44401ZM8.29884 13.7956H6.55972V12.2114H8.25689C8.70719 12.2114 8.93173 12.324 9.053 12.4347L9.05976 12.4409L9.06666 12.4469C9.18808 12.5533 9.28294 12.7106 9.28294 13.0363C9.28294 13.3736 9.18774 13.5162 9.09187 13.6002C8.99047 13.6869 8.77051 13.7956 8.29884 13.7956Z"
        stroke="#2E2E2F"
        strokeWidth="1.80688"
      />
    </svg>
  );
};

export const Undo = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_undo_svg"
        d="M10 9V5L3 12L10 19V14.9C15 14.9 18.5 16.5 21 20C20 15 17 10 10 9Z"
        fill="#737373"
      />
    </svg>
  );
};

export const Redo = () => {
  return (
    <svg
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_redo_svg"
        d="M14.5 9V5L21.5 12L14.5 19V14.9C9.5 14.9 6 16.5 3.5 20C4.5 15 7.5 10 14.5 9Z"
        fill="#737373"
      />
    </svg>
  );
};

export const Reset = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="bounty_rest_svg"
        d="M4.22302 10H1.5L6 14.5L10.5 10H7.34141C8.16508 7.6696 10.3876 6 13 6C16.3137 6 19 8.6863 19 12C19 15.3137 16.3137 18 13 18C11.3431 18 9.8431 17.3284 8.75736 16.2426L6.63604 18.364C8.26472 19.9926 10.5147 21 13 21C17.9706 21 22 16.9706 22 12C22 7.0294 17.9706 3 13 3C8.71683 3 5.13248 5.992 4.22302 10Z"
        fill="#737373"
      />
    </svg>
  );
};

export const Lock = () => {
  return (
    <svg
      width="16"
      height="21"
      viewBox="0 0 16 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M14 19V9H2V19H14ZM14 7C14.5304 7 15.0391 7.21071 15.4142 7.58579C15.7893 7.96086 16 8.46957 16 9V19C16 19.5304 15.7893 20.0391 15.4142 20.4142C15.0391 20.7893 14.5304 21 14 21H2C0.89 21 0 20.1 0 19V9C0 8.46957 0.210714 7.96086 0.585786 7.58579C0.960859 7.21071 1.46957 7 2 7C2 7 2.60948 7 3 7C3.78105 7 5 7 5 7H11V5C11 4.20435 10.6839 3.44129 10.1213 2.87868C9.55871 2.31607 8.79565 2 8 2C7.20435 2 6.44129 2.31607 5.87868 2.87868C5.31607 3.44129 5 4.20435 5 5H3C3 3.67392 3.52678 2.40215 4.46447 1.46447C5.40215 0.526784 6.67392 0 8 0C8.65661 0 9.30679 0.129329 9.91342 0.380602C10.52 0.631876 11.0712 1.00017 11.5355 1.46447C11.9998 1.92876 12.3681 2.47995 12.6194 3.08658C12.8707 3.69321 13 4.34339 13 5V7H14ZM8 16C7.46957 16 6.96086 15.7893 6.58579 15.4142C6.21071 15.0391 6 14.5304 6 14C6 13.4696 6.21071 12.9609 6.58579 12.5858C6.96086 12.2107 7.46957 12 8 12C8.53043 12 9.03914 12.2107 9.41421 12.5858C9.78929 12.9609 10 13.4696 10 14C10 14.5304 9.78929 15.0391 9.41421 15.4142C9.03914 15.7893 8.53043 16 8 16Z"
        fill="white"
      />
      <path d="M3 5H5V7H3V5Z" fill="white" />
    </svg>
  );
};
export const Unlock = () => {
  return (
    <svg
      width="16"
      height="21.000000000000004"
      xmlns="http://www.w3.org/2000/svg"
      fill="none"
    >
      <g>
        <path
          stroke="null"
          id="svg_1"
          fill="black"
          d="m13.9199,19.03753l0,-9.9931l-11.89294,0l0,9.9931l11.89294,0zm0,-11.99173c0.52567,0 1.02983,0.21056 1.40158,0.58539c0.37175,0.37481 0.58057,0.88317 0.58057,1.41323l0,9.9931c0,0.53003 -0.20882,1.03838 -0.58057,1.41322c-0.37175,0.37484 -0.87592,0.5854 -1.40158,0.5854l-11.89294,0c-1.1001,0 -1.98216,-0.89938 -1.98216,-1.99862l0,-9.9931c0,-0.53006 0.20883,-1.03842 0.58056,-1.41323c0.37172,-0.37482 0.8759,-0.58539 1.40159,-0.58539c0,0 0.60404,0 0.99108,0c0.77408,0 1.98216,0 1.98216,0l5.94647,0l0,-1.99862c0,-0.7951 -0.31328,-1.55764 -0.87086,-2.11986c-0.55758,-0.56222 -1.31387,-0.87807 -2.10237,-0.87807c-0.7885,0 -1.54479,0.31585 -2.10239,0.87807c-0.55759,0.56222 -0.87084,1.32476 -0.87084,2.11986l-1.98216,0c0,-1.32517 0.52208,-2.59606 1.4514,-3.53309c0.92931,-0.93704 2.18972,-1.46346 3.50399,-1.46346c0.65074,0 1.29514,0.12924 1.89633,0.38034c0.60119,0.25111 1.14747,0.61914 1.60763,1.08312c0.46016,0.46397 0.82517,1.01478 1.07423,1.62099c0.24906,0.60621 0.3772,1.25594 0.3772,1.9121l0,1.99862l0.99108,0zm-5.94647,8.99379c-0.52567,0 -1.02983,-0.21055 -1.40158,-0.5854c-0.37175,-0.37484 -0.58057,-0.88319 -0.58057,-1.41322c0,-0.53003 0.20882,-1.03838 0.58057,-1.41322c0.37175,-0.37484 0.87592,-0.5854 1.40158,-0.5854c0.52567,0 1.02983,0.21055 1.40158,0.5854c0.37175,0.37484 0.58057,0.88319 0.58057,1.41322c0,0.53003 -0.20882,1.03838 -0.58057,1.41322c-0.37175,0.37484 -0.87592,0.5854 -1.40158,0.5854z"
        />
      </g>
    </svg>
  );
};

export const Minus = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="rect" width="30" height="30" rx="4" fill="#F2F2F2" />
      <path
        className="path"
        d="M19.6666 15.6667H10.3333V14.3334H19.6666V15.6667Z"
        fill="black"
      />
    </svg>
  );
};

export const Plus = () => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect className="rect" width="30" height="30" rx="4" fill="#F2F2F2" />
      <path
        className="path"
        d="M19.6666 15.6667H15.6666V19.6667H14.3333V15.6667H10.3333V14.3334H14.3333V10.3334H15.6666V14.3334H19.6666V15.6667Z"
        fill="black"
      />
    </svg>
  );
};
export const ExtrusionIntrusion = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 18.0346C13.4743 17.9901 15.1964 17.3515 15.835 15.9082C16.6395 14.0899 16.8852 11.4697 16.9518 9.44812C17.0492 6.49465 14.6251 5.98151 12.0001 5.96602V5.00049C15.1689 5.01849 18.1118 5.92772 17.9948 9.47757C17.9253 11.5854 17.6246 14.4117 16.8007 16.274C16.011 18.0589 13.8689 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346ZM12.0001 18.0346C10.5257 17.9901 8.80374 17.3517 8.16516 15.9083C7.36064 14.09 7.11497 11.4698 7.04832 9.44824C6.95094 6.49479 9.37504 5.98151 12.0001 5.96602V5.00049C8.83124 5.01849 5.88828 5.92786 6.00533 9.47769C6.07483 11.5855 6.37551 14.4118 7.19947 16.2741C7.98918 18.059 10.1312 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M11.5002 19.75V14H12.5002V19.75H13.4047L12.0002 22.559L10.5957 19.75H11.5002ZM13.4047 4.24993H12.5002V5.01107C12.3344 5.00488 12.1676 5.00144 12.0002 5.00049C11.8327 5.00144 11.6659 5.00488 11.5002 5.01107V4.24993H10.5957L12.0002 1.44092L13.4047 4.24993Z"
        fill="black"
      />
    </svg>
  );
};
export const BuccalLingual = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 18.0346C13.4741 17.9901 15.1962 17.3515 15.8348 15.9082C16.6393 14.0899 16.885 11.4697 16.9516 9.44812C17.049 6.49465 14.6249 5.98151 11.9999 5.96602V5.00049C15.1687 5.01849 18.1116 5.92772 17.9946 9.47757C17.9251 11.5854 17.6244 14.4117 16.8005 16.274C16.0108 18.0589 13.8687 19.0859 11.9999 18.9933C11.9999 18.9933 11.9999 18.409 11.9999 18.0346ZM11.9999 18.0346C10.5255 17.9901 8.8035 17.3517 8.16492 15.9083C7.3604 14.09 7.11473 11.4698 7.04808 9.44824C6.9507 6.49479 9.3748 5.98151 11.9999 5.96602V5.00049C8.831 5.01849 5.88804 5.92786 6.00509 9.47769C6.07459 11.5855 6.37527 14.4118 7.19923 16.2741C7.98894 18.059 10.131 19.0859 11.9999 18.9933C11.9999 18.9933 11.9999 18.409 11.9999 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M6.6352 17.6154L10.3313 13.2106L11.0973 13.8534L7.40124 18.2582L8.09416 18.8396L5.21265 20.0886L5.94233 17.034L6.6352 17.6154ZM19.0574 5.96577L18.3645 5.38436L17.2102 6.75997C17.0007 6.49798 16.7545 6.27155 16.4781 6.0767L17.5985 4.74157L16.9056 4.16016L19.7871 2.91113L19.0574 5.96577Z"
        fill="black"
      />
    </svg>
  );
};
export const MesialDistal = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 18.0346C13.4743 17.9901 15.1964 17.3515 15.835 15.9082C16.6395 14.0899 16.8852 11.4697 16.9518 9.44812C17.0492 6.49465 14.6251 5.98151 12.0001 5.96602V5.00049C15.1689 5.01849 18.1118 5.92772 17.9948 9.47757C17.9253 11.5854 17.6246 14.4117 16.8007 16.274C16.011 18.0589 13.8689 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346ZM12.0001 18.0346C10.5257 17.9901 8.80374 17.3517 8.16516 15.9083C7.36064 14.09 7.11497 11.4698 7.04832 9.44824C6.95094 6.49479 9.37504 5.98151 12.0001 5.96602V5.00049C8.83124 5.01849 5.88828 5.92786 6.00533 9.47769C6.07483 11.5855 6.37551 14.4118 7.19947 16.2741C7.98918 18.059 10.1312 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M6.25158 12.4997H4.24993V13.4042L1.44092 11.9997L4.24993 10.5952V11.4997H6.13589C6.16809 11.8303 6.20639 12.1652 6.25158 12.4997ZM17.8642 11.4997H19.75V10.5952L22.559 11.9997L19.75 13.4042V12.4997H17.7485C17.7937 12.1652 17.832 11.8303 17.8642 11.4997Z"
        fill="black"
      />
    </svg>
  );
};
export const Rotation = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 18.0346C13.4743 17.9901 15.1964 17.3515 15.835 15.9082C16.6395 14.0899 16.8852 11.4697 16.9518 9.44812C17.0492 6.49465 14.6251 5.98151 12.0001 5.96602V5.00049C15.1689 5.01849 18.1118 5.92772 17.9948 9.47757C17.9253 11.5854 17.6246 14.4117 16.8007 16.274C16.011 18.0589 13.8689 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346ZM12.0001 18.0346C10.5257 17.9901 8.80374 17.3517 8.16516 15.9083C7.36064 14.09 7.11497 11.4698 7.04832 9.44824C6.95094 6.49479 9.37504 5.98151 12.0001 5.96602V5.00049C8.83124 5.01849 5.88828 5.92786 6.00533 9.47769C6.07483 11.5855 6.37551 14.4118 7.19947 16.2741C7.98918 18.059 10.1312 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M19.6819 10.5979L19.0508 9.97314L22 9L21.0169 11.9194L20.3835 11.2924C20.3415 11.3293 20.2991 11.3657 20.2565 11.4018C19.2487 12.2569 16.7733 13.8747 12.5 13.9931V14.381H11.5V13.9931C7.22667 13.8747 4.7513 12.2569 3.7435 11.4018C3.70107 11.3658 3.65878 11.3294 3.61688 11.2924L2.98307 11.9198L2 9.00033L4.94922 9.97347L4.3181 10.5982C4.34124 10.6182 4.36447 10.6381 4.38769 10.6578C5.25473 11.3935 7.48778 12.8962 11.5 13.0129V12.4762H12.5V13.0129C16.5122 12.8962 18.7453 11.3935 19.6123 10.6578C19.6366 10.6372 19.6598 10.6172 19.6819 10.5979ZM11.5 2.95238V2H12.5V2.95238H11.5ZM11.5 5.80952V3.90476H12.5V5.80952H11.5ZM11.5 8.66667V6.7619H12.5V8.66667H11.5ZM11.5 11.5238V9.61905H12.5V11.5238H11.5ZM11.5 17.2381V15.3333H12.5V17.2381H11.5ZM11.5 20.0952V18.1905H12.5V20.0952H11.5ZM11.5 22V21.0476H12.5V22H11.5Z"
        fill="black"
      />
    </svg>
  );
};
export const MesialHingeRotation = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.0001 18.0346C13.4743 17.9901 15.1964 17.3515 15.835 15.9082C16.6395 14.0899 16.8852 11.4697 16.9518 9.44812C17.0492 6.49465 14.6251 5.98151 12.0001 5.96602V5.00049C15.1689 5.01849 18.1118 5.92772 17.9948 9.47757C17.9253 11.5854 17.6246 14.4117 16.8007 16.274C16.011 18.0589 13.8689 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346ZM12.0001 18.0346C10.5257 17.9901 8.80374 17.3517 8.16516 15.9083C7.36064 14.09 7.11497 11.4698 7.04832 9.44824C6.95094 6.49479 9.37504 5.98151 12.0001 5.96602V5.00049C8.83124 5.01849 5.88828 5.92786 6.00533 9.47769C6.07483 11.5855 6.37551 14.4118 7.19947 16.2741C7.98918 18.059 10.1312 19.0859 12.0001 18.9933C12.0001 18.9933 12.0001 18.409 12.0001 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M11.3951 15.9934C11.3232 15.9904 10.9259 15.9735 10.6354 15.9517C9.996 15.9037 9.12833 15.8075 8.2243 15.6137C7.32438 15.4209 6.36391 15.1262 5.5527 14.6699C4.74268 14.2143 4.03357 13.5693 3.72976 12.6579C3.45688 11.8393 3.43575 11.1614 3.6204 10.6074C3.80689 10.048 4.1814 9.6805 4.57188 9.44623C4.95558 9.21602 5.36448 9.10735 5.66409 9.05448C5.79943 9.0306 5.91748 9.01724 6.00799 9.00974C6.00093 9.16038 5.99992 9.31631 6.00525 9.47769C6.01097 9.65135 6.01827 9.82989 6.0273 10.0124C5.97295 10.0182 5.90877 10.0268 5.83787 10.0393C5.60624 10.0801 5.32764 10.159 5.08635 10.3037C4.85184 10.4444 4.66385 10.6394 4.56908 10.9237C4.47249 11.2134 4.45134 11.6604 4.67844 12.3417C4.87462 12.9302 5.353 13.4102 6.04297 13.7984C6.73176 14.1858 7.58379 14.4537 8.43387 14.6359C9.27985 14.8173 10.0997 14.9086 10.7103 14.9545C10.9842 14.975 11.3286 14.9954 11.3951 14.9993C11.3951 14.777 11.3951 14.4634 11.3951 14L14.2041 15.4045L11.3951 16.809C11.3951 16.4166 11.3951 16.1667 11.3951 15.9934ZM17.9982 14.381H16.9982C16.9982 14.1347 16.9982 12.817 16.9982 12.4762H17.9982C17.9982 12.817 17.9982 14.1347 17.9982 14.381ZM16.9982 2.95238V2H17.9982V2.95238H16.9982ZM16.9982 5.80952V3.90476H17.9982V5.80952H16.9982ZM16.9982 8.66667V6.7619H17.9982V8.66667H16.9982ZM16.9982 11.5238V9.61905H17.9982V11.5238H16.9982ZM16.9982 17.2381V15.3333H17.9982V17.2381H16.9982ZM16.9982 20.0952V18.1905H17.9982V20.0952H16.9982ZM16.9982 22V21.0476H17.9982V22H16.9982Z"
        fill="black"
      />
    </svg>
  );
};
export const DistalHingeRotation = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12 18.0346C13.4742 17.9901 15.1963 17.3515 15.8349 15.9082C16.6394 14.0899 16.8851 11.4697 16.9517 9.44812C17.0491 6.49465 14.625 5.98151 12 5.96602V5.00049C15.1688 5.01849 18.1117 5.92772 17.9947 9.47757C17.9252 11.5854 17.6245 14.4117 16.8006 16.274C16.0109 18.0589 13.8688 19.0859 12 18.9933C12 18.9933 12 18.409 12 18.0346ZM12 18.0346C10.5256 17.9901 8.80362 17.3517 8.16504 15.9083C7.36052 14.09 7.11485 11.4698 7.0482 9.44824C6.95082 6.49479 9.37492 5.98151 12 5.96602V5.00049C8.83112 5.01849 5.88816 5.92786 6.00521 9.47769C6.07471 11.5855 6.37539 14.4118 7.19935 16.2741C7.98906 18.059 10.1311 19.0859 12 18.9933C12 18.9933 12 18.409 12 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M12.6049 14.9902C12.6049 14.9902 12.9852 14.9676 13.2897 14.9447C13.9003 14.8989 14.7202 14.8075 15.5661 14.6262C16.4162 14.444 17.2682 14.1761 17.957 13.7886C18.647 13.4005 19.1254 12.9205 19.3216 12.332C19.5487 11.6507 19.5275 11.2037 19.4309 10.9139C19.3361 10.6296 19.1482 10.4347 18.9136 10.294C18.6724 10.1492 18.3938 10.0704 18.1621 10.0295C18.0912 10.017 18.027 10.0085 17.9727 10.0026C17.9817 9.82014 17.989 9.64161 17.9948 9.46795C18.0001 9.30656 17.9991 9.15063 17.992 9C18.0825 9.0075 18.2006 9.02086 18.3359 9.04474C18.6355 9.09761 19.0444 9.20627 19.4281 9.43648C19.8186 9.67076 20.1931 10.0383 20.3796 10.5977C20.5643 11.1516 20.5431 11.8296 20.2702 12.6482C19.9664 13.5596 19.2573 14.2045 18.4473 14.6602C17.6361 15.1165 16.6756 15.4111 15.7757 15.604C14.8717 15.7977 14.004 15.8939 13.3646 15.9419C13.0741 15.9637 12.6768 15.9807 12.6049 15.9836V16.7993L9.79586 15.3948L12.6049 13.9903V14.9902ZM7 14.381H6C6 14.1347 6 12.817 6 12.4762H7C7 12.817 7 14.1347 7 14.381ZM6 2.95238V2H7V2.95238H6ZM6 5.80952V3.90476H7V5.80952H6ZM6 8.66667V6.7619H7V8.66667H6ZM6 11.5238V9.61905H7V11.5238H6ZM6 17.2381V15.3333H7V17.2381H6ZM6 20.0952V18.1905H7V20.0952H6ZM6 22V21.0476H7V22H6Z"
        fill="black"
      />
    </svg>
  );
};
export const CrownAngulation = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.9999 18.0346C13.4741 17.9901 15.1962 17.3515 15.8348 15.9082C16.6393 14.0899 16.885 11.4697 16.9516 9.44812C17.049 6.49465 14.6249 5.98151 11.9999 5.96602V5.00049C15.1687 5.01849 18.1116 5.92772 17.9946 9.47757C17.9251 11.5854 17.6244 14.4117 16.8005 16.274C16.0108 18.0589 13.8687 19.0859 11.9999 18.9933C11.9999 18.9933 11.9999 18.409 11.9999 18.0346ZM11.9999 18.0346C10.5255 17.9901 8.8035 17.3517 8.16492 15.9083C7.3604 14.09 7.11473 11.4698 7.04808 9.44824C6.9507 6.49479 9.3748 5.98151 11.9999 5.96602V5.00049C8.831 5.01849 5.88804 5.92786 6.00509 9.47769C6.07459 11.5855 6.37527 14.4118 7.19923 16.2741C7.98894 18.059 10.131 19.0859 11.9999 18.9933C11.9999 18.9933 11.9999 18.409 11.9999 18.0346Z"
        fill="#9E9C9A"
      />
      <path
        d="M4.3292 8.29992C4.31293 8.35045 4.29669 8.40299 4.2806 8.45753C4.05786 9.21229 3.86096 10.3559 3.99359 11.8719C4.12622 13.3879 4.5194 14.4875 4.87104 15.1999C4.89776 15.2541 4.92426 15.306 4.9504 15.3558L5.61344 14.7994L6.34312 17.8541L3.46161 16.605L4.16886 16.0115C4.10574 15.8994 4.04042 15.7765 3.9743 15.6425C3.57179 14.8269 3.14161 13.6074 2.99739 11.959C2.85317 10.3106 3.06565 9.04141 3.32149 8.17448C3.36238 8.03592 3.40435 7.90775 3.44608 7.79005L2.65015 7.33052L5.271 5.6001L5.08283 8.73503L4.3292 8.29992ZM20.5472 7.78989C20.589 7.90758 20.6309 8.03574 20.6718 8.1743C20.9277 9.04122 21.1401 10.3104 20.9959 11.9588C20.8517 13.6072 20.4215 14.8267 20.019 15.6423C19.9529 15.7763 19.8875 15.8993 19.8244 16.0114L20.5317 16.6049L17.6502 17.8539L18.3799 14.7993L19.0429 15.3556C19.069 15.3059 19.0956 15.2539 19.1223 15.1997C19.4739 14.4873 19.8671 13.3877 19.9997 11.8717C20.1324 10.3557 19.9355 9.21211 19.7127 8.45735C19.6966 8.40281 19.6804 8.35028 19.6641 8.29976L18.9105 8.73485L18.7223 5.59991L21.3432 7.33034L20.5472 7.78989ZM14 11C14 12.1046 13.1046 13 12 13C10.8954 13 9.99998 12.1046 9.99998 11C9.99998 9.89543 10.8954 9 12 9C13.1046 9 14 9.89543 14 11ZM11.5 2H12.5V2.95238H11.5V2ZM11.5 3.90476H12.5V5.80952H11.5V3.90476ZM11.5 8.55001V6.7619H12.5V8.55001C12.3384 8.51722 12.1712 8.5 12 8.5C11.8288 8.5 11.6615 8.51722 11.5 8.55001ZM11.5 13.45C11.6615 13.4828 11.8288 13.5 12 13.5C12.1712 13.5 12.3384 13.4828 12.5 13.45V14.381H11.5V13.45ZM11.5 15.3333H12.5V17.2381H11.5V15.3333ZM11.5 18.1905H12.5V20.0952H11.5V18.1905ZM11.5 21.0476H12.5V22H11.5V21.0476Z"
        fill="black"
      />
    </svg>
  );
};
export const Inclination = () => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.9427 13.272C13.388 13.4606 13.0413 13.4606 12.1399 13.3977C11.1692 13.272 10.2678 12.5804 10.3371 11.6374C10.4758 10.7572 10.6838 9.43699 10.9611 8.6197C11.0244 8.44043 11.0841 8.27098 11.1406 8.11032C11.58 6.86234 11.8327 6.14452 12.1399 5.47614C12.4866 4.72172 13.2493 4.97319 13.4573 5.47614C13.4728 5.51112 13.488 5.54513 13.503 5.57868C13.7578 6.14819 13.9543 6.58719 14.1507 9.43699C14.1797 9.85811 14.2074 10.2327 14.2321 10.5661C14.3839 12.6216 14.42 13.1097 13.9427 13.272ZM11.8681 14.1706C13.1242 14.4233 13.9836 14.0442 14.3141 13.8546C14.9752 13.6019 15.1735 14.8657 14.843 15.308C13.6738 17.1083 13.5258 17.6276 13.3328 18.3045C13.3294 18.3165 13.326 18.3286 13.3225 18.3407C13.277 18.5146 13.2315 18.755 13.1812 19.0207C13.0123 19.9135 12.7893 21.0917 12.3308 20.9943C10.7443 20.6152 9.15769 18.3408 9.02548 15.6239C8.89326 12.907 9.28994 12.2119 9.88491 12.7173C9.95045 12.7643 10.0404 12.8618 10.1546 12.9856C10.5014 13.3614 11.0726 13.9805 11.8681 14.1706Z"
        fill="#9E9C9A"
      />
      <path
        d="M10.2433 5.76024C10.476 5.99722 10.7555 6.18736 11.0665 6.31542L10.3001 7.4766L9.47652 6.92198L10.2433 5.76024ZM12.9336 6.31542C13.2446 6.18736 13.524 5.99722 13.7568 5.76024L14.5236 6.92198L13.6999 7.4766L12.9336 6.31542ZM8.71635 9.87628L7.89273 9.32165L8.94859 7.72187L9.77221 8.27649L8.71635 9.87628ZM7.13256 12.2759L6.30895 11.7213L7.3648 10.1215L8.18842 10.6762L7.13256 12.2759ZM5.54878 14.6756L4.72516 14.121L5.78102 12.5212L6.60463 13.0758L5.54878 14.6756ZM4.49292 16.2754L3.6693 15.7208L4.19723 14.9209L5.02085 15.4755L4.49292 16.2754ZM15.2837 9.87628L14.2279 8.27649L15.0515 7.72187L16.1073 9.32165L15.2837 9.87628ZM16.8675 12.2759L15.8117 10.6762L16.6353 10.1215L17.6911 11.7213L16.8675 12.2759ZM18.4513 14.6756L17.3954 13.0758L18.2191 12.5212L19.2749 14.121L18.4513 14.6756ZM19.5072 16.2754L18.9792 15.4755L19.8028 14.9209L20.3308 15.7208L19.5072 16.2754ZM13.4751 5.33347C13.2539 5.58296 12.9715 5.77599 12.6518 5.88855C12.6462 5.89052 12.6406 5.89246 12.635 5.89438C12.4357 5.96251 12.2221 5.99945 12 5.99945C11.7717 5.99945 11.5524 5.9604 11.3483 5.88855C11.0285 5.77599 10.7462 5.58296 10.5249 5.33347C10.507 5.31326 10.4895 5.29268 10.4724 5.27174C10.19 4.92607 10.0203 4.48291 10.0203 3.99973C10.0203 2.89531 10.9067 2 12 2C13.0934 2 13.9798 2.89531 13.9798 3.99973C13.9798 4.51218 13.7889 4.97961 13.4751 5.33347ZM4.94922 17.9735L4.31809 18.5982C4.34124 18.6182 4.36447 18.6381 4.38769 18.6578C5.2901 19.4235 7.67227 21.0201 12 21.0201C16.3277 21.0201 18.7099 19.4235 19.6123 18.6578C19.6365 18.6372 19.6597 18.6172 19.6819 18.5979L19.0508 17.9731L22 17L21.0169 19.9194L20.3835 19.2924C20.3414 19.3293 20.299 19.3657 20.2565 19.4018C19.21 20.2897 16.5811 22 12 22C7.41884 22 4.78998 20.2897 3.7435 19.4018C3.70106 19.3658 3.65878 19.3293 3.61687 19.2924L2.98307 19.9198L2 17.0003L4.94922 17.9735Z"
        fill="black"
      />
    </svg>
  );
};
export const ExistingAtt = () => {
  return (
    <svg
      width="36"
      height="49"
      viewBox="0 0 36 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.25"
        y="0.0588379"
        width="35.75"
        height="48"
        rx="4"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M24.4688 35.4338L30.8125 24.0588L24.4688 12.6838H11.7812L5.4375 24.0588L11.7812 35.4338H24.4688ZM26.769 29.5174L29.8223 24.0581L26.8887 18.809L23.9663 13.5588H12.1982L6.43195 24.0588L12.1982 34.5589H23.9561L26.769 29.5174Z"
        fill="#864A4D"
      />
      <path
        d="M29.8223 24.0581L26.769 29.5174L23.9561 34.5589H12.1982L6.43195 24.0588L12.1982 13.5588H23.9663L26.8886 18.809L29.8223 24.0581Z"
        fill="#EA9A9C"
      />
    </svg>
  );
};
export const Extrusion = () => {
  return (
    <svg
      width="30"
      height="48"
      viewBox="0 0 30 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="29.5" height="48" rx="4" fill="#F2F2F2" />
      <path d="M27 17H6L2.5 25.75L23.5 27.5L27 17Z" fill="#EA9A9C" />
      <path d="M23.5 27.5L27 17V31L6 29.25L2.5 25.75" fill="#864A4D" />
    </svg>
  );
};
export const VBRA = () => {
  return (
    <svg
      width="30"
      height="48"
      viewBox="0 0 30 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect width="29.5" height="48" rx="4" fill="#F2F2F2" />
      <path
        d="M19.125 36.25H10.375C9.4125 36.25 8.625 35.4625 8.625 34.5L6 13.5C6 12.5375 6.7875 11.75 7.75 11.75H21.75C22.7125 11.75 23.5 12.5375 23.5 13.5L20.875 34.5C20.875 35.4625 20.0875 36.25 19.125 36.25Z"
        fill="#864A4D"
      />
      <path
        d="M18.25 35.375H10.375C9.4125 35.375 8.625 34.5875 8.625 33.625L6 13.5C6 12.5375 6.7875 11.75 7.75 11.75H20.875C21.8375 11.75 22.625 12.5375 22.625 13.5L20 33.625C20 34.5875 19.2125 35.375 18.25 35.375Z"
        fill="#EA9A9C"
      />
    </svg>
  );
};
export const HBRA = () => {
  return (
    <svg
      width="30"
      height="48"
      viewBox="0 0 30 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="29.5" height="48" rx="4" fill="#F2F2F2" />
      <path
        d="M25.75 32.75L4.75 30.125C3.7875 30.125 3 29.3375 3 28.375V19.625C3 18.6625 3.7875 17.875 4.75 17.875L25.75 15.25C26.7125 15.25 27.5 16.0375 27.5 17V31C27.5 31.9625 26.7125 32.75 25.75 32.75Z"
        fill="#864A4D"
      />
      <path
        d="M24.875 31.875L4.75 29.25C3.7875 29.25 3 28.4625 3 27.5V19.625C3 18.6625 3.7875 17.875 4.75 17.875L24.875 15.25C25.8375 15.25 26.625 16.0375 26.625 17V30.125C26.625 31.0875 25.8375 31.875 24.875 31.875Z"
        fill="#EA9A9C"
      />
    </svg>
  );
};
export const BiplaneRotational = () => {
  return (
    <svg
      width="44"
      height="48"
      viewBox="0 0 44 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.666626"
        y="0.217529"
        width="42.6667"
        height="47.375"
        rx="4"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M14.8459 15.5315C12.3157 20.228 14.1508 26.226 19.0326 29.0445C23.9144 31.863 30.0263 30.4532 32.8285 25.9137L14.8459 15.5315Z"
        fill="#864A4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.1546 13.6768C15.7155 14.1619 15.322 14.6988 14.9835 15.285C12.2633 19.9966 14.5799 25.3319 19.5271 28.1881C24.4742 31.0444 30.253 30.383 32.9732 25.6714C33.3117 25.0851 33.5799 24.4759 33.7804 23.8531L16.1546 13.6768Z"
        fill="#EA9A9C"
      />
    </svg>
  );
};
export const Rotational = () => {
  return (
    <svg
      width="43"
      height="47"
      viewBox="0 0 43 47"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        x="0.333374"
        y="0.217529"
        width="42.6667"
        height="46"
        rx="4"
        fill="#F2F2F2"
      />
      <path
        d="M13.8621 32.8683C18.0102 24.52 23.2511 10.9216 23.2511 10.9216L29.9407 27.4696C27.9456 39.7926 14.6837 36.5065 13.3927 33.103C13.3927 33.103 13.6797 33.2354 13.8621 32.8683Z"
        fill="#864A4D"
      />
      <path
        d="M13.8621 32.1642C18.0102 23.8159 23.2511 10.2175 23.2511 10.2175L29.9407 27.3524C25.7157 37.4924 17.1483 35.4112 13.3927 33.1031C13.3927 33.1031 13.6797 32.5313 13.8621 32.1642Z"
        fill="#EA9A9C"
      />
    </svg>
  );
};
export const RootControl = () => {
  return (
    <svg
      width="43"
      height="48"
      viewBox="0 0 43 48"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        y="0.217529"
        width="42.6667"
        height="47.375"
        rx="4"
        fill="#F2F2F2"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.33337 28.5886C14.0503 28.4497 17.8334 24.3911 17.8334 19.4048C17.8334 14.4185 14.0503 10.3599 9.33337 10.221L9.33337 28.5886Z"
        fill="#864A4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.33337 28.4067C7.89922 28.5285 8.48452 28.5925 9.08337 28.5925C13.8959 28.5925 16.9584 24.4582 16.9584 19.405C16.9584 14.3519 13.8959 10.2175 9.08337 10.2175C8.48453 10.2175 7.89922 10.2815 7.33337 10.4034L7.33337 28.4067Z"
        fill="#EA9A9C"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M33.3334 19.2214C28.6165 19.3604 24.8334 23.4189 24.8334 28.4053C24.8334 33.3916 28.6165 37.4501 33.3334 37.5891L33.3334 19.2214Z"
        fill="#864A4D"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M35.3334 19.4034C34.7675 19.2815 34.1822 19.2175 33.5834 19.2175C28.7709 19.2175 25.7084 23.3519 25.7084 28.405C25.7084 33.4582 28.7709 37.5925 33.5834 37.5925C34.1822 37.5925 34.7675 37.5285 35.3334 37.4067L35.3334 19.4034Z"
        fill="#EA9A9C"
      />
    </svg>
  );
};
export const Oblique = () => {
  return (
    <svg
      width="30"
      height="49"
      viewBox="0 0 30 49"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect x="0.5" width="29.5" height="48.2176" rx="4" fill="#F2F2F2" />
      <path
        d="M27.4371 31.2176L16.9371 13.0311L7.60941 14.375L16.5939 33.4365L27.4371 31.2176Z"
        fill="#EA9A9C"
      />
      <path
        d="M16.5939 33.4365L27.4371 31.2176L15.3128 38.2176L6.32832 19.1561L7.60941 14.375"
        fill="#864A4D"
      />
    </svg>
  );
};
export const TrashCan = () => {
  return (
    <svg
      width="15"
      height="19"
      viewBox="0 0 15 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M1.5 16.0588C1.5 16.5893 1.71071 17.098 2.08579 17.4731C2.46086 17.8481 2.96957 18.0588 3.5 18.0588H11.5C12.0304 18.0588 12.5391 17.8481 12.9142 17.4731C13.2893 17.098 13.5 16.5893 13.5 16.0588V4.05884H1.5V16.0588ZM3.5 6.05884H11.5V16.0588H3.5V6.05884ZM11 1.05884L10 0.0588379H5L4 1.05884H0.5V3.05884H14.5V1.05884H11Z"
        fill="black"
      />
    </svg>
  );
};
export const Tooth = () => {
  return (
    <svg
      width="42"
      height="64"
      viewBox="0 0 42 64"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        className="tooth_svg"
        d="M0.460693 48.7844C0.460693 56.7979 6.95696 63.2942 14.9705 63.2942H26.5783C34.5919 63.2942 41.0881 56.7979 41.0881 48.7844V8.88242C41.0881 4.47497 37.5152 0.902031 33.1078 0.902031H8.44109C4.03364 0.902031 0.460693 4.47498 0.460693 8.88242V48.7844Z"
        fill="#D9D9D9"
      />
    </svg>
  );
};

export const EditIPR = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M9.99771 22.6022C11.8405 22.5466 13.9931 21.7483 14.7913 19.9442C15.797 17.6713 16.1041 14.3961 16.1873 11.8691C16.3091 8.17727 13.279 7.53585 9.99771 7.51648V6.30957C13.9587 6.33207 17.6373 7.46861 17.4911 11.9059C17.4042 14.5407 17.0283 18.0736 15.9985 20.4015C15.0113 22.6326 12.3337 23.9163 9.99771 23.8006C9.99771 23.8006 9.99771 23.0702 9.99771 22.6022ZM9.99771 22.6022C8.15471 22.5466 6.00224 21.7486 5.20401 19.9443C4.19836 17.6715 3.89127 14.3962 3.80796 11.8693C3.68624 8.17745 6.71636 7.53585 9.99771 7.51648V6.30957C6.03661 6.33207 2.35791 7.46878 2.50422 11.9061C2.5911 14.5408 2.96695 18.0737 3.9969 20.4016C4.98404 22.6327 7.66158 23.9163 9.99771 23.8006C9.99771 23.8006 9.99771 23.0702 9.99771 22.6022Z"
        fill="#9E9C9A"
      />
      <path
        d="M21.2455 22.6015C23.0883 22.5458 25.2409 21.7476 26.0391 19.9435C27.0448 17.6706 27.3519 14.3954 27.4351 11.8684C27.5569 8.17654 24.5268 7.53511 21.2455 7.51575V6.30884C25.2065 6.33134 28.8851 7.46787 28.7389 11.9052C28.652 14.54 28.2761 18.0729 27.2463 20.4007C26.2591 22.6319 23.5815 23.9156 21.2455 23.7999C21.2455 23.7999 21.2455 23.0695 21.2455 22.6015ZM21.2455 22.6015C19.4025 22.5458 17.25 21.7479 16.4518 19.9436C15.4462 17.6707 15.1391 14.3955 15.0558 11.8685C14.934 8.17671 17.9642 7.53511 21.2455 7.51575V6.30884C17.2844 6.33134 13.6057 7.46805 13.752 11.9053C13.8389 14.5401 14.2148 18.073 15.2447 20.4008C16.2318 22.632 18.9094 23.9156 21.2455 23.7999C21.2455 23.7999 21.2455 23.0695 21.2455 22.6015Z"
        fill="#9E9C9A"
      />
      <mask id="path-3-inside-1_240_16028" fill="white">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M19.5808 15.9488L20.8309 15.9488C20.8882 15.3604 20.9564 14.7642 21.0369 14.1688L19.5808 14.1688V12.5588L15.7364 14.481L11.8938 12.5598L11.8938 14.1698L10 14.1698C10.0804 14.7652 10.1486 15.3613 10.2059 15.9497L11.8938 15.9497L11.8938 17.5598L15.7382 15.6376L19.5808 17.5588V15.9488Z"
        />
      </mask>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M19.5808 15.9488L20.8309 15.9488C20.8882 15.3604 20.9564 14.7642 21.0369 14.1688L19.5808 14.1688V12.5588L15.7364 14.481L11.8938 12.5598L11.8938 14.1698L10 14.1698C10.0804 14.7652 10.1486 15.3613 10.2059 15.9497L11.8938 15.9497L11.8938 17.5598L15.7382 15.6376L19.5808 17.5588V15.9488Z"
        fill="black"
      />
      <path
        d="M20.8309 15.9488V16.5738H21.398L21.453 16.0094L20.8309 15.9488ZM19.5808 15.9488V15.3238H18.9558V15.9488H19.5808ZM21.0369 14.1688L21.6562 14.2525L21.752 13.5438L21.0369 13.5438V14.1688ZM19.5808 14.1688H18.9558V14.7938H19.5808V14.1688ZM19.5808 12.5588H20.2058V11.5476L19.3013 11.9998L19.5808 12.5588ZM15.7364 14.481L15.4569 15.04L15.7364 15.1798L16.0159 15.04L15.7364 14.481ZM11.8938 12.5598L12.1733 12.0007L11.2688 11.5485L11.2688 12.5598L11.8938 12.5598ZM11.8938 14.1698L11.8938 14.7948H12.5188L12.5188 14.1698L11.8938 14.1698ZM10 14.1698L10 13.5448L9.28489 13.5448L9.38063 14.2534L10 14.1698ZM10.2059 15.9497L9.58387 16.0103L9.63884 16.5747H10.2059L10.2059 15.9497ZM11.8938 15.9497H12.5188V15.3247H11.8938V15.9497ZM11.8938 17.5598H11.2688L11.2688 18.571L12.1733 18.1188L11.8938 17.5598ZM15.7382 15.6376L16.0177 15.0785L15.7382 14.9388L15.4587 15.0785L15.7382 15.6376ZM19.5808 17.5588L19.3013 18.1179L20.2058 18.5701V17.5588H19.5808ZM20.8309 15.3238L19.5808 15.3238V16.5738H20.8309V15.3238ZM20.4175 14.0851C20.3359 14.6889 20.2669 15.2928 20.2089 15.8882L21.453 16.0094C21.5096 15.428 21.5769 14.8396 21.6562 14.2525L20.4175 14.0851ZM19.5808 14.7938L21.0369 14.7938V13.5438L19.5808 13.5438V14.7938ZM18.9558 12.5588V14.1688H20.2058V12.5588H18.9558ZM16.0159 15.04L19.8603 13.1179L19.3013 11.9998L15.4569 13.922L16.0159 15.04ZM16.0159 13.922L12.1733 12.0007L11.6143 13.1188L15.4569 15.04L16.0159 13.922ZM11.2688 12.5598L11.2688 14.1698L12.5188 14.1698L12.5188 12.5598L11.2688 12.5598ZM11.8938 13.5448L10 13.5448L10 14.7948L11.8938 14.7948L11.8938 13.5448ZM9.38063 14.2534C9.45994 14.8405 9.52724 15.4289 9.58387 16.0103L10.828 15.8892C10.77 15.2937 10.7009 14.6898 10.6194 14.0861L9.38063 14.2534ZM10.2059 16.5747L11.8938 16.5747L11.8938 15.3247L10.2059 15.3247L10.2059 16.5747ZM11.2688 15.9497L11.2688 17.5598H12.5188V15.9497H11.2688ZM12.1733 18.1188L16.0177 16.1966L15.4587 15.0785L11.6143 17.0007L12.1733 18.1188ZM19.8603 16.9998L16.0177 15.0785L15.4587 16.1966L19.3013 18.1179L19.8603 16.9998ZM18.9558 15.9488V17.5588H20.2058V15.9488H18.9558Z"
        fill="#F5F5F5"
        mask="url(#path-3-inside-1_240_16028)"
      />
    </svg>
  );
};

export const EditSpacing = () => {
  return (
    <svg
      width="30"
      height="31"
      viewBox="0 0 30 31"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_240_16042)">
        <path
          d="M3.74771 22.6015C5.59046 22.5458 7.74308 21.7476 8.54134 19.9435C9.54696 17.6706 9.85408 14.3954 9.93734 11.8684C10.0591 8.17654 7.02896 7.53511 3.74771 7.51575V6.30884C7.70871 6.33134 11.3873 7.46787 11.2411 11.9052C11.1542 14.54 10.7783 18.0729 9.74846 20.4007C8.76134 22.6319 6.08371 23.9156 3.74771 23.7999C3.74771 23.7999 3.74771 23.0695 3.74771 22.6015ZM3.74771 22.6015C1.90471 22.5458 -0.247765 21.7479 -1.04599 19.9436C-2.05164 17.6707 -2.35873 14.3955 -2.44204 11.8685C-2.56376 8.17671 0.46636 7.53511 3.74771 7.51575V6.30884C-0.21339 6.33134 -3.89209 7.46805 -3.74578 11.9053C-3.6589 14.5401 -3.28305 18.073 -2.2531 20.4008C-1.26596 22.632 1.41158 23.9156 3.74771 23.7999C3.74771 23.7999 3.74771 23.0695 3.74771 22.6015Z"
          fill="#9E9C9A"
        />
        <path
          d="M20.6251 22.6031C22.3148 22.5475 24.2886 21.7492 25.0206 19.9449C25.9427 17.6718 26.2243 14.3962 26.3007 11.8689C26.4123 8.17673 23.6338 7.53524 20.6251 7.51587V6.30884C24.2571 6.33134 27.6302 7.46799 27.4961 11.9058C27.4165 14.5408 27.0718 18.074 26.1275 20.4022C25.2223 22.6335 22.7671 23.9174 20.6251 23.8016C20.6251 23.8016 20.6251 23.0712 20.6251 22.6031ZM20.6251 22.6031C18.9351 22.5475 16.9614 21.7494 16.2295 19.945C15.3073 17.6719 15.0257 14.3963 14.9493 11.8691C14.8377 8.1769 17.6162 7.53524 20.6251 7.51587V6.30884C16.9929 6.33134 13.6197 7.46817 13.7539 11.9059C13.8335 14.5409 14.1782 18.0742 15.1226 20.4023C16.0277 22.6336 18.4829 23.9174 20.6251 23.8016C20.6251 23.8016 20.6251 23.0712 20.6251 22.6031Z"
          fill="#9E9C9A"
        />
        <mask id="path-3-inside-1_240_16042" fill="white">
          <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M13.0301 15.9488V17.5588L18.0301 15.0588L13.0301 12.5588V14.1688H11.25V12.5588L6.25 15.0588L11.25 17.5588V15.9488H13.0301Z"
          />
        </mask>
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M13.0301 15.9488V17.5588L18.0301 15.0588L13.0301 12.5588V14.1688H11.25V12.5588L6.25 15.0588L11.25 17.5588V15.9488H13.0301Z"
          fill="black"
        />
        <path
          d="M13.0301 17.5588H12.4051V18.5701L13.3096 18.1179L13.0301 17.5588ZM13.0301 15.9488H13.6551V15.3238H13.0301V15.9488ZM18.0301 15.0588L18.3096 15.6179L19.4277 15.0588L18.3096 14.4998L18.0301 15.0588ZM13.0301 12.5588L13.3096 11.9998L12.4051 11.5476V12.5588H13.0301ZM13.0301 14.1688V14.7938H13.6551V14.1688H13.0301ZM11.25 14.1688H10.625V14.7938H11.25V14.1688ZM11.25 12.5588H11.875V11.5476L10.9705 11.9998L11.25 12.5588ZM6.25 15.0588L5.97049 14.4998L4.85245 15.0588L5.97049 15.6179L6.25 15.0588ZM11.25 17.5588L10.9705 18.1179L11.875 18.5701V17.5588H11.25ZM11.25 15.9488V15.3238H10.625V15.9488H11.25ZM13.6551 17.5588V15.9488H12.4051V17.5588H13.6551ZM17.7506 14.4998L12.7506 16.9998L13.3096 18.1179L18.3096 15.6179L17.7506 14.4998ZM12.7506 13.1179L17.7506 15.6179L18.3096 14.4998L13.3096 11.9998L12.7506 13.1179ZM13.6551 14.1688V12.5588H12.4051V14.1688H13.6551ZM11.25 14.7938H13.0301V13.5438H11.25V14.7938ZM11.875 14.1688V12.5588H10.625V14.1688H11.875ZM10.9705 11.9998L5.97049 14.4998L6.52951 15.6179L11.5295 13.1179L10.9705 11.9998ZM5.97049 15.6179L10.9705 18.1179L11.5295 16.9998L6.52951 14.4998L5.97049 15.6179ZM11.875 17.5588V15.9488H10.625V17.5588H11.875ZM13.0301 15.3238H11.25V16.5738H13.0301V15.3238Z"
          fill="#F5F5F5"
          mask="url(#path-3-inside-1_240_16042)"
        />
        <rect x="-5" y="3.73535" width="8.75" height="26.25" fill="white" />
      </g>
      <defs>
        <clipPath id="clip0_240_16042">
          <rect
            width="30"
            height="30"
            fill="white"
            transform="translate(0 0.0588379)"
          />
        </clipPath>
      </defs>
    </svg>
  );
};

export const BiteIcon = () => (
  <svg
    width="21"
    height="24"
    viewBox="0 0 21 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M19.957 10.3497C20.0701 10.9453 19.7031 11.4862 19.1732 11.5905C17.4232 11.9348 16.0952 11.9214 14.4459 11.5934C13.9164 11.4881 13.55 10.9467 13.6631 10.3508L14.4229 6.34778C14.5085 5.89637 14.8521 5.55012 15.2788 5.4691C15.935 5.34447 16.3739 5.29295 16.7976 5.29562C17.2233 5.29829 17.6619 5.35577 18.3214 5.47797C18.7623 5.55965 19.1148 5.91239 19.2013 6.36821L19.957 10.3497Z"
      stroke="#6C6C6C"
      strokeWidth="1.35516"
    />
    <path
      d="M6.78734 10.4623C6.90051 11.0628 6.53061 11.5935 6.01625 11.6849C4.80389 11.9002 3.8291 11.8931 2.68217 11.6878C2.16835 11.5959 1.79838 11.0641 1.91159 10.4633L2.45252 7.59285C2.5384 7.13714 2.88191 6.79357 3.29892 6.71952C4.12787 6.57231 4.54445 6.57996 5.37883 6.72667C5.81157 6.80276 6.16385 7.15367 6.25049 7.61342L6.78734 10.4623Z"
      stroke="#6C6C6C"
      strokeWidth="1.35516"
    />
    <path
      d="M13.1282 10.4153C13.2428 11.015 12.8725 11.5528 12.3484 11.6495C10.9178 11.9131 9.79531 11.9038 8.44429 11.6524C7.92051 11.555 7.55048 11.0164 7.66513 10.4163L8.29092 7.14135C8.37762 6.68759 8.72132 6.34371 9.1433 6.26692C10.1526 6.08327 10.614 6.09316 11.6291 6.27475C12.0662 6.35294 12.419 6.70394 12.5064 7.16166L13.1282 10.4153Z"
      stroke="#6C6C6C"
      strokeWidth="1.35516"
    />
    <path
      d="M19.957 13.9751C20.0701 13.3795 19.7031 12.8387 19.1732 12.7344C17.4232 12.39 16.0952 12.4035 14.4459 12.7315C13.9164 12.8368 13.55 13.3781 13.6631 13.9741L14.4229 17.9771C14.5085 18.4285 14.8521 18.7747 15.2788 18.8558C15.935 18.9804 16.3739 19.0319 16.7976 19.0292C17.2233 19.0266 17.6619 18.9691 18.3214 18.8469C18.7623 18.7652 19.1148 18.4125 19.2013 17.9566L19.957 13.9751Z"
      stroke="#6C6C6C"
      strokeWidth="1.35516"
    />
    <path
      d="M6.78734 13.8626C6.90051 13.2621 6.53061 12.7313 6.01625 12.64C4.80389 12.4247 3.8291 12.4317 2.68217 12.637C2.16835 12.729 1.79838 13.2607 1.91159 13.8615L2.45252 16.732C2.5384 17.1877 2.88191 17.5313 3.29892 17.6053C4.12787 17.7525 4.54445 17.7449 5.37883 17.5982C5.81157 17.5221 6.16385 17.1712 6.25049 16.7114L6.78734 13.8626Z"
      stroke="#6C6C6C"
      strokeWidth="1.35516"
    />
    <path
      d="M13.1282 13.9096C13.2428 13.3098 12.8725 12.772 12.3484 12.6754C10.9178 12.4117 9.79531 12.4211 8.44429 12.6724C7.92051 12.7699 7.55048 13.3085 7.66513 13.9085L8.29092 17.1835C8.37762 17.6373 8.72132 17.9812 9.14331 18.0579C10.1526 18.2416 10.614 18.2317 11.6291 18.0501C12.0662 17.9719 12.419 17.6209 12.5064 17.1632L13.1282 13.9096Z"
      stroke="#6C6C6C"
      strokeWidth="1.35516"
    />
    <path
      d="M18.42 4.9173C18.6795 2.66195 15.5459 -0.914691 0.936005 2.82162"
      stroke="#6C6C6C"
      strokeWidth="1.80688"
      strokeLinecap="round"
    />
    <path
      d="M18.42 19.1608C18.6795 21.4162 15.5459 24.9928 0.936004 21.2565"
      stroke="#6C6C6C"
      strokeWidth="1.80688"
      strokeLinecap="round"
    />
  </svg>
);
export const PencilIcon = () => (
  <svg
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.06 6L12 6.94L2.92 16H2V15.08L11.06 6ZM14.66 0C14.41 0 14.15 0.1 13.96 0.29L12.13 2.12L15.88 5.87L17.71 4.04C18.1 3.65 18.1 3 17.71 2.63L15.37 0.29C15.17 0.09 14.92 0 14.66 0ZM11.06 3.19L0 14.25V18H3.75L14.81 6.94L11.06 3.19Z"
      fill="#009ACE"
    />
  </svg>
);

export const SavingIcon = () => (
  <svg
    width="16"
    height="17"
    viewBox="0 0 16 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.6667 5.83335L10 8.50002H12C12 9.56089 11.5786 10.5783 10.8284 11.3284C10.0783 12.0786 9.06089 12.5 8.00002 12.5C7.33335 12.5 6.68669 12.3334 6.13335 12.0334L5.16002 13.0067C5.98002 13.5267 6.95335 13.8334 8.00002 13.8334C9.41451 13.8334 10.7711 13.2715 11.7713 12.2713C12.7715 11.2711 13.3334 9.91451 13.3334 8.50002H15.3334M4.00002 8.50002C4.00002 7.43915 4.42145 6.42174 5.17159 5.67159C5.92174 4.92145 6.93915 4.50002 8.00002 4.50002C8.66669 4.50002 9.31335 4.66669 9.86669 4.96669L10.84 3.99335C10.02 3.47335 9.04669 3.16669 8.00002 3.16669C6.58553 3.16669 5.22898 3.72859 4.22878 4.72878C3.22859 5.72898 2.66669 7.08553 2.66669 8.50002H0.666687L3.33335 11.1667L6.00002 8.50002"
      fill="white"
    />
  </svg>
);
export const SavedIcon = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 14 14"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M6.99998 0.333313C3.33331 0.333313 0.333313 3.33331 0.333313 6.99998C0.333313 10.6666 3.33331 13.6666 6.99998 13.6666C10.6666 13.6666 13.6666 10.6666 13.6666 6.99998C13.6666 3.33331 10.6666 0.333313 6.99998 0.333313ZM6.99998 12.3333C4.05998 12.3333 1.66665 9.93998 1.66665 6.99998C1.66665 4.05998 4.05998 1.66665 6.99998 1.66665C9.93998 1.66665 12.3333 4.05998 12.3333 6.99998C12.3333 9.93998 9.93998 12.3333 6.99998 12.3333ZM10.06 4.05331L5.66665 8.44665L3.93998 6.72665L2.99998 7.66665L5.66665 10.3333L11 4.99998L10.06 4.05331Z"
      fill="#21A300"
    />
  </svg>
);
export const Elastics = () => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 27 28"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.3868 22.7571L11.6422 21.8041L11.6422 21.8041L11.3868 22.7571ZM9.48083 19.4559L8.52779 19.2005L8.52779 19.2005L9.48083 19.4559ZM14.688 20.8512L13.7349 20.5958L13.7349 20.5958L14.688 20.8512ZM20.4765 18.2313L20.1318 19.1558L20.1318 19.1558L20.4765 18.2313ZM21.7507 14.8144L22.0955 13.89L22.0955 13.89L21.7507 14.8144ZM18.2172 7.68013L19.1702 7.93549L19.1702 7.93549L18.2172 7.68013ZM13.01 6.28487L13.9631 6.54024L13.9631 6.54024L13.01 6.28487ZM6.48303 9.12099L6.13828 10.0455L6.13828 10.0455L6.48303 9.12099ZM5.20883 12.5379L5.55358 11.6134L5.55358 11.6134L5.20883 12.5379ZM8.07685 13.6074L7.7321 14.5319L8.07685 13.6074ZM8.45793 9.85744L8.11318 10.7819L8.45793 9.85744ZM19.1203 17.7256L18.7755 18.6501L18.7755 18.6501L19.1203 17.7256ZM11.6422 21.8041C10.7306 21.5598 10.1896 20.6228 10.4339 19.7113L8.52779 19.2005C8.00146 21.1648 9.16715 23.1838 11.1314 23.7102L11.6422 21.8041ZM13.7349 20.5958C13.4907 21.5074 12.5537 22.0483 11.6422 21.8041L11.1314 23.7102C13.0957 24.2365 15.1147 23.0708 15.641 21.1065L13.7349 20.5958ZM13.9962 19.6207L13.7349 20.5958L15.641 21.1065L15.9023 20.1314L13.9962 19.6207ZM20.8213 17.3069L19.465 16.8011L18.7755 18.6501L20.1318 19.1558L20.8213 17.3069ZM21.8976 16.8152C21.7361 17.2482 21.2542 17.4683 20.8213 17.3069L20.1318 19.1558C21.5859 19.6981 23.2043 18.9589 23.7465 17.5047L21.8976 16.8152ZM21.406 15.7389C21.8389 15.9004 22.059 16.3823 21.8976 16.8152L23.7465 17.5047C24.2888 16.0506 23.5496 14.4322 22.0955 13.89L21.406 15.7389ZM19.1566 14.9001L21.406 15.7389L22.0955 13.89L19.8461 13.0512L19.1566 14.9001ZM17.2641 7.42476L16.5933 9.92832L18.4994 10.4391L19.1702 7.93549L17.2641 7.42476ZM16.0558 5.33197C16.9674 5.57622 17.5084 6.51319 17.2641 7.42476L19.1702 7.93549C19.6965 5.97122 18.5308 3.9522 16.5666 3.42587L16.0558 5.33197ZM13.9631 6.54024C14.2073 5.62868 15.1443 5.08772 16.0558 5.33197L16.5666 3.42587C14.6023 2.89955 12.5833 4.06524 12.057 6.0295L13.9631 6.54024ZM13.582 7.96233L13.9631 6.54024L12.057 6.0295L11.6759 7.4516L13.582 7.96233ZM6.13828 10.0455L8.11318 10.7819L8.80268 8.93297L6.82777 8.19651L6.13828 10.0455ZM5.06196 10.5371C5.22342 10.1041 5.70531 9.884 6.13828 10.0455L6.82777 8.19651C5.37365 7.65425 3.75526 8.39347 3.213 9.84759L5.06196 10.5371ZM5.55358 11.6134C5.12061 11.4519 4.9005 10.9701 5.06196 10.5371L3.213 9.84759C2.67075 11.3017 3.40996 12.9201 4.86409 13.4624L5.55358 11.6134ZM8.4216 12.6829L5.55358 11.6134L4.86409 13.4624L7.7321 14.5319L8.4216 12.6829ZM10.4339 19.7113L10.9849 17.6547L9.07884 17.144L8.52779 19.2005L10.4339 19.7113ZM7.7321 14.5319C8.78717 14.9253 9.37028 16.0563 9.07884 17.144L10.9849 17.6547C11.5397 15.5845 10.4298 13.4318 8.4216 12.6829L7.7321 14.5319ZM11.6759 7.4516C11.3424 8.6961 10.0099 9.38314 8.80268 8.93297L8.11318 10.7819C10.4109 11.6388 12.9473 10.3311 13.582 7.96233L11.6759 7.4516ZM19.8461 13.0512C18.7911 12.6577 18.2079 11.5267 18.4994 10.4391L16.5933 9.92832C16.0386 11.9986 17.1484 14.1513 19.1566 14.9001L19.8461 13.0512ZM15.9023 20.1314C16.2358 18.8869 17.5684 18.1999 18.7755 18.6501L19.465 16.8011C17.1673 15.9443 14.6309 17.252 13.9962 19.6207L15.9023 20.1314Z"
      fill="#6C6C6C"
    />
  </svg>
);
export const RecordsIcon = () => (
  <svg
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12.8074 14.5C15.4774 14.5 20.8074 15.84 20.8074 18.5V21.5H4.80737V18.5C4.80737 15.84 10.1374 14.5 12.8074 14.5ZM12.8074 5.5C13.8682 5.5 14.8857 5.92143 15.6358 6.67157C16.3859 7.42172 16.8074 8.43913 16.8074 9.5C16.8074 10.5609 16.3859 11.5783 15.6358 12.3284C14.8857 13.0786 13.8682 13.5 12.8074 13.5C11.7465 13.5 10.7291 13.0786 9.97895 12.3284C9.2288 11.5783 8.80737 10.5609 8.80737 9.5C8.80737 8.43913 9.2288 7.42172 9.97895 6.67157C10.7291 5.92143 11.7465 5.5 12.8074 5.5ZM12.8074 16.4C9.83737 16.4 6.70737 17.86 6.70737 18.5V19.6H18.9074V18.5C18.9074 17.86 15.7774 16.4 12.8074 16.4ZM12.8074 7.4C12.2504 7.4 11.7163 7.62125 11.3224 8.01508C10.9286 8.4089 10.7074 8.94305 10.7074 9.5C10.7074 10.057 10.9286 10.5911 11.3224 10.9849C11.7163 11.3788 12.2504 11.6 12.8074 11.6C13.3643 11.6 13.8985 11.3788 14.2923 10.9849C14.6861 10.5911 14.9074 10.057 14.9074 9.5C14.9074 8.94305 14.6861 8.4089 14.2923 8.01508C13.8985 7.62125 13.3643 7.4 12.8074 7.4Z"
      fill="#2E2E2F"
    />
  </svg>
);
export const Bite = () => (
  <svg
    width="31"
    height="31"
    viewBox="0 0 31 31"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M25.4851 13.6302C25.6102 14.2895 25.204 14.8881 24.6175 15.0036C22.6805 15.3848 21.2106 15.3699 19.385 15.0068C18.7988 14.8902 18.3932 14.291 18.5184 13.6314L19.3594 9.20054C19.4543 8.70088 19.8346 8.31762 20.3068 8.22795C21.0333 8.09 21.519 8.03297 21.988 8.03592C22.4592 8.03888 22.9447 8.1025 23.6747 8.23777C24.1627 8.32818 24.5529 8.71862 24.6486 9.22316L25.4851 13.6302Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
    />
    <path
      d="M10.9078 13.7548C11.0331 14.4195 10.6237 15.0069 10.0543 15.1081C8.71238 15.3464 7.6334 15.3386 6.36389 15.1113C5.79515 15.0095 5.38563 14.421 5.51095 13.756L6.1097 10.5787C6.20475 10.0743 6.58498 9.69398 7.04655 9.61201C7.96411 9.44907 8.42521 9.45754 9.34877 9.61993C9.82777 9.70415 10.2177 10.0926 10.3136 10.6015L10.9078 13.7548Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
    />
    <path
      d="M17.9263 13.7028C18.0532 14.3666 17.6434 14.9619 17.0632 15.0689C15.4797 15.3607 14.2373 15.3504 12.7419 15.0722C12.1621 14.9643 11.7525 14.3681 11.8794 13.704L12.5721 10.0789C12.6681 9.57667 13.0485 9.19604 13.5156 9.11104C14.6327 8.90776 15.1435 8.91871 16.2671 9.1197C16.7509 9.20625 17.1414 9.59477 17.2382 10.1014L17.9263 13.7028Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
    />
    <path
      d="M25.4851 17.6431C25.6102 16.9838 25.204 16.3852 24.6175 16.2698C22.6805 15.8886 21.2105 15.9034 19.3849 16.2665C18.7988 16.3831 18.3932 16.9823 18.5184 17.6419L19.3594 22.0728C19.4543 22.5724 19.8346 22.9557 20.3068 23.0454C21.0332 23.1833 21.519 23.2403 21.9879 23.2374C22.4592 23.2344 22.9446 23.1708 23.6747 23.0356C24.1627 22.9451 24.5529 22.5547 24.6486 22.0502L25.4851 17.6431Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
    />
    <path
      d="M10.9078 17.5185C11.0331 16.8538 10.6236 16.2664 10.0543 16.1653C8.71236 15.9269 7.63339 15.9347 6.36387 16.162C5.79513 16.2638 5.38562 16.8523 5.51093 17.5173L6.10968 20.6946C6.20474 21.199 6.58497 21.5793 7.04654 21.6613C7.96409 21.8242 8.4252 21.8158 9.34875 21.6534C9.82775 21.5692 10.2177 21.1807 10.3136 20.6719L10.9078 17.5185Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
    />
    <path
      d="M17.9263 17.5705C18.0532 16.9067 17.6434 16.3114 17.0632 16.2044C15.4797 15.9126 14.2373 15.923 12.7418 16.2011C12.1621 16.309 11.7525 16.9052 11.8794 17.5694L12.5721 21.1944C12.668 21.6966 13.0485 22.0773 13.5156 22.1623C14.6327 22.3656 15.1435 22.3546 16.2671 22.1536C16.7509 22.0671 17.1414 21.6785 17.2382 21.1719L17.9263 17.5705Z"
      stroke="#6C6C6C"
      strokeWidth="1.5"
    />
    <path
      d="M23.7842 7.61707C24.0714 5.12065 20.6029 1.16174 4.43147 5.29739"
      stroke="#6C6C6C"
      strokeWidth="2"
      strokeLinecap="round"
    />
    <path
      d="M23.7842 23.3829C24.0714 25.8793 20.6029 29.8383 4.43146 25.7026"
      stroke="#6C6C6C"
      strokeWidth="2"
      strokeLinecap="round"
    />
  </svg>
);
export const BiteStep = () => (
  <svg
    width="43"
    height="57"
    viewBox="0 0 43 57"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <line
      x1="30.1248"
      y1="-22.2929"
      x2="-41.293"
      y2="49.1249"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="52.1248"
      y1="-3.29289"
      x2="-19.293"
      y2="68.1249"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="34.3675"
      y1="-18.0502"
      x2="-37.0503"
      y2="53.3676"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="56.3675"
      y1="0.949783"
      x2="-15.0503"
      y2="72.3676"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="42.8526"
      y1="-9.56511"
      x2="-28.5652"
      y2="61.8527"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="64.8526"
      y1="9.43489"
      x2="-6.56518"
      y2="80.8527"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="47.0953"
      y1="-5.32243"
      x2="-24.3225"
      y2="66.0954"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="69.0953"
      y1="13.6776"
      x2="-2.3225"
      y2="85.0954"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
    <line
      x1="76.1248"
      y1="13.6776"
      x2="4.70704"
      y2="85.0954"
      stroke="black"
      strokeOpacity="0.3"
      strokeWidth="2"
    />
  </svg>
);
export const TranslateIcon = () => (
  <svg
    width="800px"
    height="800px"
    viewBox="0 0 512 512"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fill="var(--ci-primary-color, #000000)"
      d="M230.2,356.821l14.425-30.654a573.693,573.693,0,0,1-40.421-44.777q15.881-21.418,29.594-43.958A543.369,543.369,0,0,0,292.212,104H344V72H200V16H168V72H16v32H75.77a545.123,545.123,0,0,0,71.448,153.959c6.811-8.406,13.706-17.432,20.566-27.031A512.677,512.677,0,0,1,109.13,104H258.867c-29.727,97.53-84.546,169.208-126.64,213.119-48.993,51.107-91.952,76.86-92.38,77.114l1.621,2.738L48,408l8.14,13.774c1.873-1.106,46.474-27.729,98.389-81.68q15.38-15.982,29.44-32.931A608.138,608.138,0,0,0,230.2,356.821Z"
      className="ci-primary"
    />
    <path
      fill="var(--ci-primary-color, #000000)"
      d="M333.722,200,328,212.516,209.379,472h35.185l36.571-80h141.73l36.571,80h35.185L370.278,200ZM328,360H295.764L328,289.484l24-52.5L408.236,360Z"
      className="ci-primary"
    />
  </svg>
);
export const BrightnessIcon = () => (
  <svg
    width="25"
    height="25"
    viewBox="0 0 25 25"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <g clipPath="url(#clip0_3179_5254)">
      <path
        d="M20.9365 15.349L24.2465 12.039L20.9365 8.72903V4.03903H16.2465L12.9365 0.729034L9.62653 4.03903H4.93653V8.72903L1.62653 12.039L4.93653 15.349V20.039H9.62653L12.9365 23.349L16.2465 20.039H20.9365V15.349ZM12.9365 18.039V6.03903C16.2465 6.03903 18.9365 8.72903 18.9365 12.039C18.9365 15.349 16.2465 18.039 12.9365 18.039Z"
        fill="#2E2E2F"
      />
    </g>
    <defs>
      <clipPath id="clip0_3179_5254">
        <rect
          width="24"
          height="24"
          fill="white"
          transform="translate(0.936523 0.039032)"
        />
      </clipPath>
    </defs>
  </svg>
);
export const Ruler = () => (
  <svg
    width="25"
    height="27"
    viewBox="0 0 25 27"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M4.98987 17.8345L6.32446 16.5075L7.39515 17.5631L8.19439 16.7714L7.1237 15.7082L8.19439 14.6375L10.0568 16.5075L10.856 15.7082L8.99364 13.8383L10.0568 12.7751L11.1275 13.8383L11.9267 13.039L10.856 11.9759L11.9267 10.9052L13.7891 12.7751L14.5884 11.9759L12.726 10.1059L13.7891 9.0428L14.8523 10.1059L15.659 9.3067L14.5884 8.24356L15.659 7.17287L17.5139 9.0428L18.3207 8.24356L16.4583 6.37362L17.7853 5.03903L20.9899 8.24356L8.19439 21.039L4.98987 17.8345Z"
      fill="#2E2E2F"
    />
  </svg>
);
export const Roots = () => (
  <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M5 0C2 0 0 3 0 6C0 8.11 1 11 2 12C3 13 4 20 6 20C10.54 20 8 13 10 13C12 13 9.46 20 14 20C16 20 17 13 18 12C19 11 20 8.11 20 6C20 3 18 0 15 0C12 0 12 1 10 1C8 1 8 0 5 0ZM5 2C7 2 8 3 10 3C12 3 13 2 15 2C16.67 2 18 4 18 6C18 7.75 17.14 10.11 16.19 11.06C15.33 11.92 14.06 17.94 13.5 17.94C13.29 17.94 13 16.88 13 15.59C13 13.55 12.43 11 10 11C7.57 11 7 13.55 7 15.59C7 16.88 6.71 17.94 6.5 17.94C5.94 17.94 4.67 11.92 3.81 11.06C2.86 10.11 2 7.75 2 6C2 4 3.33 2 5 2Z" fill="#6C6C6C" />
  </svg>
)